import advancedCard from '@/assets/images/section/description/advanced-card.png';
import centerCentent from '@/assets/images/section/description/center-centent.png';
import bannerSliderImg from '@/assets/images/section/description/banner-slider.webp';
import cardCompareTwoImage from '@/assets/images/section/description/card-compare-two-image-2.png';
import cardDualImg from '@/assets/images/section/description/card-dual-img.png';
import cardMusicians from '@/assets/images/section/description/card-musicians.png';
import videoSliderImg from '@/assets/images/section/description/card-slider-video.webp';
import cardSmoking from '@/assets/images/section/description/card-smoking.png';
import cardSonaImg from '@/assets/images/section/description/card-sona.webp';
import videoImg from '@/assets/images/section/description/card-video.gif';
import cardWithTableCompareImg from '@/assets/images/section/description/card-with-table-compare.png';
import collapsibleProductGridImg from '@/assets/images/section/description/collapsible-product-grid.png';
import faqGridImg from '@/assets/images/section/description/faq-grid.png';
import faqGridImg02 from '@/assets/images/section/description/faq-grid-02.png';
import faqGridImg03 from '@/assets/images/section/description/faq-grid-03.png';
import faqGridImg04 from '@/assets/images/section/description/faq-grid-04.png';
import findAnswer from '@/assets/images/section/description/findAnswer.png';
import freestyleImgGrid from '@/assets/images/section/description/freestyle-grid-img.webp';
import headingText from '@/assets/images/section/description/heading-text.png';
import iconWithTextSliderImg from '@/assets/images/section/description/icons-text-slider.png';
import marqueeBasicText from '@/assets/images/section/description/marquee.png';
import reviewInfiniteMarqueeImg from '@/assets/images/section/description/review-infinite-marquee.gif';
import reviewGridKindLokalImage from '@/assets/images/section/description/review-loka.png';
import subscribeEmailImg from '@/assets/images/section/description/subscribe-email.png';
import textCarousel from '@/assets/images/section/description/text-carousel.png';
import textSurvey from '@/assets/images/section/description/text-survey.png';
import tinoGridImg from '@/assets/images/section/description/tino-grid.png';
import eco from '@/assets/images/section/description/eco.png';
import freestyle from '@/assets/images/section/description/freestyle.png';
import freestyleImgText from '@/assets/images/section/description/freestyleImgText.png';
import countdownImg from '@/assets/images/section/hurryboxTpl/countdown.png';
import sizingChartImg from '@/assets/images/section/hurryboxTpl/s-sizing-chart.webp';
import freestyleImg from '@/assets/images/section/hurryboxTpl/freestyle.png';
import productGrid from '@/assets/images/section/description/moka-grid.png';
import iconwtext from '@/assets/images/section/description/moka-icon-w-text.png';
import questionFaq from '@/assets/images/section/description/moka-qa.png';
import satelliteGrid from '@/assets/images/section/description/moka-satellite.png';
import moka from '@/assets/images/section/description/moka.png';
import guaranteedSafeCheckoutImg from '@/assets/images/section/order-policy/guaranteed-safe-checkout.png';
import orderInfoImg from '@/assets/images/section/order-policy/order-info.png';
import productReviewsImage from '@/assets/images/section/description/product-reviews.png';
import reviewGridImage from '@/assets/images/section/description/review-grid.png';
import reviewGridImage02 from '@/assets/images/section/description/review-grid-02.png';
import shakeri from '@/assets/images/section/description/shakeri.png';
import cardAccordionsImg from '@/assets/images/section/description/s-accordion.webp';
import productReviewsSection02Img from '@/assets/images/section/description/product-reviews-02.png';
import productReviewsSection03Img from '@/assets/images/section/description/product-reviews-03.png';
import productReviewsSection04Img from '@/assets/images/section/description/product-reviews-04.png';
import productReviewsSection05Img from '@/assets/images/section/description/product-reviews-05.png';
import marqueeImageImg from '@/assets/images/section/description/marquee-img.webp';
import marqueetinoImg from '@/assets/images/section/description/marqueetino-img.webp';
import tabsSectionImg from '@/assets/images/section/description/tabs-img.webp';
import cardMediaSliderImg from '@/assets/images/section/description/card-media-slider.png';
import cardMediaSlider02Img from '@/assets/images/section/description/card-media-slider-02.png';
import cardMediaSlider03Img from '@/assets/images/section/description/card-media-slider-03.png';
import cardFeeSizeImgImg from '@/assets/images/section/description/freesize-img.png';
import tableSectionImg from '@/assets/images/section/description/table-img.png';
import itemsGridSectionImg from '@/assets/images/section/description/items-grid-img.png';
import itemsGridSection02Img from '@/assets/images/section/description/items-grid-02.png';
import cardStepInstructionsImg from '@/assets/images/section/description/card-step-instructions.png';
import purchaseIncentiveImg from '@/assets/images/section/description/purchase-incentive.png';
import socialMediaImg from '@/assets/images/section/description/social-media.png';
import featuredOfferImg from '@/assets/images/section/description/featured-offer.png';
import postSectionImg from '@/assets/images/section/description/post.png';
import cardReviewSectionImg from '@/assets/images/section/description/card-review.png';
import cardStepSectionImg from '@/assets/images/section/description/card-step.png';
import tableBenefitsComparisonImg from '@/assets/images/section/description/table-benefits-comparison.png';
import bannerB1SectionImg from '@/assets/images/section/description/banner-b1.webp';
import itemsSlideB1SectionImg from '@/assets/images/section/description/b1-slide.webp';
import cardBasicB1SectionImg from '@/assets/images/section/description/prev-basic-b1.webp';
import cardCompareB1SectionImg from '@/assets/images/section/description/prev-compare-b1.webp';
import bannerBasicB1SectionImg from '@/assets/images/section/description/prev-banner-basic-b1.webp';
import tableSmallB1SectionImg from '@/assets/images/section/description/prev-table-b1.webp';
import iconWithTextB1SectionImg from '@/assets/images/section/description/prev-icon-with-text-b1.webp';
import socialCommentSectionImg from '@/assets/images/section/description/social-comment.png';
import cardFeatureSectionImg from '@/assets/images/section/description/card-feature.png';
import cardReview02Img from '@/assets/images/section/description/card-review-02.png';
import cardMediaImg from '@/assets/images/section/description/card-media.png';
import cardKeyFeaturesImg from '@/assets/images/section/description/card-key-features.png';
import imageWithTextBasicImg from '@/assets/images/section/description/image-with-text.webp';
import reviewGridSection03Img from '@/assets/images/section/description/review-grid-section-03.webp';
import faqCardImg from '@/assets/images/section/description/faq-card.png';
import bannerMediaImg from '@/assets/images/section/description/banner-media.png';
import cardMultiToolImg from '@/assets/images/section/description/card-multi-tool-img.webp';
import tableMultiToolImg from '@/assets/images/section/description/table-multi-tool.webp';
import reviewTitanImg from '@/assets/images/section/description/review-titan.webp';
import cardMultiToolDoubleImg from '@/assets/images/section/description/doublecard2.webp';
import policyAccordionBasicImg from '@/assets/images/section/description/policy-accordion.webp';
import guaranteedSafeCheckoutImg02 from '@/assets/images/section/order-policy/guaranteed-safe-checkout-02.png';
import saintbrandShippingImg from '@/assets/images/section/order-policy/saintbrand-shipping.png';
import freestyleOrderPolicyImg from '@/assets/images/section/order-policy/freestyle-order-policy.png';
import textWithButtonSectionImg from '@/assets/images/section/description/text-with-button.png';
import faqVitalSectionImg from '@/assets/images/section/description/faq-vital.png';
import cardVitalSliderSectionImg from '@/assets/images/section/description/card-slider-vital.png';
import cardVitalSlider02SectionImg from '@/assets/images/section/description/card-vital-02-slider.webp';
import cardVitalSurroundSectionImg from '@/assets/images/section/description/card-vital-surround.webp';
import cardVitalTabSectionImg from '@/assets/images/section/description/card-vital-tab.webp';
import trustBadgeImg from '@/assets/images/section/order-policy/trust-badge.png';
import cardCompareProductSectionImg from '@/assets/images/section/description/card-compare-product.png';
import markqueueRowsImg from '@/assets/images/section/description/markqueue.webp';
import fbPost03Img from '@/assets/images/section/description/fb-post-03.webp';
import faqGridImg05 from '@/assets/images/section/description/faq-grid-05.png';
import itemsGridSection03Img from '@/assets/images/section/description/items-grid-03.png';
import itemsGridSection04Img from '@/assets/images/section/description/items-grid-04.png';
import reviewGridSection04Img from '@/assets/images/section/description/review-grid-section-04.png';
import reviewGridSection05Img from '@/assets/images/section/description/review-grid-section-05.png';
import itemsGridSection05Img from '@/assets/images/section/description/items-grid-05.png';
import itemsGridSection06Img from '@/assets/images/section/description/items-grid-06.png';
import cardBasicSectionImg from '@/assets/images/section/description/card-basic.png';
import itemsGridMediaSectionImg from '@/assets/images/section/description/items-grid-media.png';
import cardStepInstructions02Img from '@/assets/images/section/description/card-step-instructions-02.png';
import bannerBasicSectionImg from '@/assets/images/section/description/banner-basic.png';
import freestyleInfoSectionImg from '@/assets/images/section/description/freestyle-info.png';
import productReviewsSection06Img from '@/assets/images/section/description/product-reviews-06.png';
import reviewVitalSectionImg from '@/assets/images/section/description/review-vital-img.png';
import faqGridImg06 from '@/assets/images/section/description/faq-grid-06.jpg';
import moneyBackGuaranteeSectionImg from '@/assets/images/section/description/section-money-back-guarantee.jpg';
import hurryboxYuriSectionImg from '@/assets/images/section/description/harrybox-yuri.png';
import policyYuriAccordionSectionImg from '@/assets/images/section/description/policy-yuri.webp';
import policyYuriListSectionImg from '@/assets/images/section/order-policy/policy-01.webp';
import policyYuriVideosSectionImg from '@/assets/images/section/order-policy/policy-videos.webp';
import policyYuriReivewSectionImg from '@/assets/images/section/order-policy/policy-yuri-review.webp';
import cardMultiToolYuriSectionImg from '@/assets/images/section/description/card-multi-yuri.webp';
import cardCompareYuriSectionImg from '@/assets/images/section/description/card-compare-yuri.webp';
import cardTimelineYuriSectionImg from '@/assets/images/section/description/card-timeline-yuri.webp';
import cardSliderYuri02SectionImg from '@/assets/images/section/description/card-slider-yuri.webp';
import cardStatisticsYuriSectionImg from '@/assets/images/section/description/card-statistics-yuri.webp';
import reviewSliderYuriSectionImg from '@/assets/images/section/description/review-slider-yuri.webp';
import marqueeYuriSectionImg from '@/assets/images/section/description/marquee-yuri.webp';
import fastvaluedealReviewsSectionImg from '@/assets/images/section/description/fastvaluedeal-reviews.png';
import bannerFastvaluedealSectionImg from '@/assets/images/section/description/banner-fastvaluedeal.webp';
import cardFastvaluedealTitleImgSectionImg from '@/assets/images/section/description/fastvaluedeal-title-image.webp';
import sliderFastvaluedeal01SectionImg from '@/assets/images/section/description/slider-fastvaluedeal.webp';
import fastvaluedealCountdownSectionImg from '@/assets/images/section/description/fastvaluedeal-countdown.png';
import fastvaluedealFaqSectionImg from '@/assets/images/section/description/fastvaluedeal-faq.png';
import fastvaluedealMoneyBackGuaranteeSectionImg from '@/assets/images/section/description/fastvaluedeal-money-back-guarantee.png';
import fastvaluedealReviewerSectionImg from '@/assets/images/section/description/fastvaluedeal-reviewer.png';
import fastvaluedealCtaSectionImg from '@/assets/images/section/description/fastvaluedeal-cta.png';
import fastvaluedealCardBasicSectionImg from '@/assets/images/section/description/fastvaluedeal-card-basic.png';
import fastvaluedealCardStepSectionImg from '@/assets/images/section/description/fastvaluedeal-card-step.png';
import fastvaluedealCompareBenefitsSectionImg from '@/assets/images/section/description/fastvaluedeal-compare-benefits.png';
import fastvaluedealTableSectionImg from '@/assets/images/section/description/fastvaluedeal-table.png';
import cardBannerGatorzSectionImg from '@/assets/images/section/description/gatorz-banner.webp';
import cardGatorzCustomSectionImg from '@/assets/images/section/description/gatorz-card-custom.webp';
import cardGatorzGridItemSectionImg from '@/assets/images/section/description/gatorz-grid-item.webp';
import cardBannerRivoneedSectionImg from '@/assets/images/section/description/banner-rivoneed.webp';
import cardSatelliteRivoneedSectionImg from '@/assets/images/section/description/card-satellite-rivoneed.webp';
import cardWithSliderRivoneedSectionImg from '@/assets/images/section/description/card-with-slider-rivoneed.webp';
import cardGridItemRivoneedSectionImg from '@/assets/images/section/description/grid-item-rivoneed.webp';
import cardBanner02RivoneedSectionImg from '@/assets/images/section/description/banner-02-rivoneed.webp';
import cardSliderRivoneedSectionImg from '@/assets/images/section/description/card-slider-rivoneed.webp';
import marqueeRivoneedSectionImg from '@/assets/images/section/description/marquee-rivoneed.webp';
import cardBasicRivoneedSectionImg from '@/assets/images/section/description/card-basic-rivoneed.webp';
import cardBadgeRivoneedSectionImg from '@/assets/images/section/description/card-badge-rivoneed.webp';
import cardFaqRivoneedSectionImg from '@/assets/images/section/description/faq-rivoneed.webp';
import gatorzYoutubeSectionImg from '@/assets/images/section/description/gatorz-youtube.png';
import gatorzCompareImageSectionImg from '@/assets/images/section/description/gatorz-compare-image.png';
import gatorzReviewsSectionImg from '@/assets/images/section/description/gatorz-reviews.png';
import saintbrandReviewsSectionImg from '@/assets/images/section/description/saintbrand-reviews.jpg';
import gatorzSupportSectionImg from '@/assets/images/section/description/gatorz-support.png';
import gatorzFrameSpecsSectionImg from '@/assets/images/section/description/gatorz-frame-specs.png';
import gatorzPolicySectionImg from '@/assets/images/section/description/gatorz-policy.png';
import saintbrandInfiniteMarqueeSectionImg from '@/assets/images/section/description/saintbrand-infinite-marquee.png';
import saintbrandFeaturesGridSectionImg from '@/assets/images/section/description/saintbrand-features-grid.jpg';
import markqueueOrthopedicImg from '@/assets/images/section/description/markqueue-orthopedic.png';
import orthopedicFeaturesGridImg from '@/assets/images/section/description/orthopedic-features-grid.png';
import orthopedicCardFeaturesImg from '@/assets/images/section/description/orthopedic-card-features.jpg';
import orthopedicCardReviewImg from '@/assets/images/section/description/orthopedic-card-review.png';
import orthopedicCardBasicImg from '@/assets/images/section/description/orthopedic-card-basic.png';
import losaprilyReviewsSectionImg from '@/assets/images/section/description/losaprily-reviews.png';
import losaprilyImagesGridSectionImg from '@/assets/images/section/description/losaprily-images-grid.png';
import losaprilyCardMediaWithSliderImg from '@/assets/images/section/description/thumbnail-lora-media-with-slider.webp';
import losaprilyCardTabWithContentImg from '@/assets/images/section/description/thumbnail-tab-with-content-losa.webp';
import losaprilyCardBannerImg from '@/assets/images/section/description/losaprily-card-banner.png';
import shopzovyaMarqueeImage from '@/assets/images/section/description/thumbnail-marquee-shop.webp';
import sowhatbuyCardBasicSectionImg from '@/assets/images/section/description/sowhatbuy-card-basic.png';
import sowhatbuyGuaranteeMarqueeSectionImg from '@/assets/images/section/description/sowhatbuy-guarantee-marquee.png';
import sowhatbuyFeaturesSliderSectionImg from '@/assets/images/section/description/sowhatbuy-features-slider.jpg';
import sowhatbuyRewardSectionImg from '@/assets/images/section/description/sowhatbuy-reward.jpg';
import sowhatbuyCardImageSectionImg from '@/assets/images/section/description/sowhatbuy-card-image.png';
import sowhatbuyCardBannerImg from '@/assets/images/section/description/thumbnail-sowhatbuy-banner.webp';
import sowhatbuyCardItemsImg from '@/assets/images/section/description/thumbnail-sowhatbuy-items.webp';
import sowhatbuyCardCompareImg from '@/assets/images/section/description/card-compare-sowhatbuy.webp';
import tryherReviewGridImg from '@/assets/images/section/description/tryher-review-grid.png';
import tryherTimelineImg from '@/assets/images/section/description/tryher-timeline.png';
import tryherCardCompareImg from '@/assets/images/section/description/tryher-card-compare.png';
import tryherCardBasicImg from '@/assets/images/section/description/tryher-card-basic.png';
import tryherGridPercentImg from '@/assets/images/section/description/tryher-grid-percent.png';
import imageWithTextCol1SectionImg from '@/assets/images/section/description/col1-thumbnail.webp';
import sideBySideGridIconSectionImg from '@/assets/images/section/description/sbs-grid-icon.webp';
import leonieandcoReviewGridImg from '@/assets/images/section/order-policy/leonieandco-review-grid.png';
import cedrowFreetypeContentImg from '@/assets/images/section/description/leonieandco-review-grid.webp';
import cardCedrowWithTabImg from '@/assets/images/section/description/thumbnail-cedrow-with-tab.webp';
import cardCedrowSideBySideImg from '@/assets/images/section/description/thumbnail-cedrow-side-by-side.webp';
import cardCedrowWithTabelImg from '@/assets/images/section/description/thumbnail-cedrow-with-table.webp';
import cardCedrowBenefitsPolicyImg from '@/assets/images/section/order-policy/thumbnail-cedrow-benefis-policy.png';
import cardCedrowGridIconsImg from '@/assets/images/section/description/thumbnail-cedrow-grid-icons.webp';
import upairyTabsImg from '@/assets/images/section/description/upairy-tabs.png';
import upairyTimelineImg from '@/assets/images/section/description/upairy-timeline.png';
import upairyCardImg from '@/assets/images/section/description/upairy-card.png';
import upairyCompareCardImg from '@/assets/images/section/description/upairy-compare-card.png';
import konfortifyFbImg from '@/assets/images/section/description/konfortify-fb.png';
import konfortifyCardBasicImg from '@/assets/images/section/description/konfortify-card-basic.png';
import konfortifyBannerImg from '@/assets/images/section/description/konfortify-banner.png';
import konfortifyReviewGridImg from '@/assets/images/section/description/konfortify-review-grid.png';
import furnitureshopBannerImg from '@/assets/images/section/description/furnitureshop-banner.png';
import furnitureshopCarouselImg from '@/assets/images/section/description/furnitureshop-carousel.png';
import furnitureCardStepImg from '@/assets/images/section/description/furnitureshop-card-step.png';
import furnitureGridSliderImg from '@/assets/images/section/description/furnitureshop-grid-slider.png';
import furnitureGridSlider02Img from '@/assets/images/section/description/furnitureshop-grid-slider-02.png';
import furnitureSpecificationImg from '@/assets/images/section/description/furnitureshop-specification.png';
import furnitureRewardImg from '@/assets/images/section/description/furnitureshop-reward.png';
import furnitureBanner02Img from '@/assets/images/section/description/furnitureshop-banner-02.png';
import furnitureBanner03Img from '@/assets/images/section/description/furnitureshop-banner-03.png';
import furnitureFaqImg from '@/assets/images/section/description/furnitureshop-faq.png';
import feetscareListImageSectionImg from '@/assets/images/section/description/thumbnail-list-img-feetscare.png';
import feetscareListItemSectionImg from '@/assets/images/section/description/thumbnail-list-item-feetscare.webp';
import feetscareStatSectionImg from '@/assets/images/section/description/thumbnail-side-by-side-feetscare.webp';
import feetscareSatelliteSectionImg from '@/assets/images/section/description/thumbnail-satellite-feetscare.webp';
import manchestoreCompareSliderImg from '@/assets/images/section/description/manchestore-compare-slider.png';
import manchestoreBannerImg from '@/assets/images/section/description/manchestore-banner.png';
import sofyreTabsReviewSectionImg from '@/assets/images/section/description/thumbnail-tab-slide-sofyre.webp';
import sofyreTimelineImg from '@/assets/images/section/description/sofyre-timeline.png';
import sofyreIngredientsImg from '@/assets/images/section/description/sofyre-ingredients.png';
import sofyreUserManualImg from '@/assets/images/section/description/sofyre-user-manual.png';
import sofyreComparisonSectionImg from '@/assets/images/section/description/thumbnail-compare-sofyre.webp';
import madamsizeCalculatorImg from '@/assets/images/section/hurryboxTpl/thumbnail-size-calculator.webp';
import thumbnailEskiinPolicyImg from '@/assets/images/section/order-policy/thumbnail-eskiin-policy.webp';
import thumbnailEskiinImg from '@/assets/images/section/hurryboxTpl/thumbnail-eskiin.webp';

import {
  advancedSection,
  bannerSliderSection,
  cardAccordionsSection,
  cardCompareTwoImageSection,
  cardDualImageSection,
  // cardHaveViewMoreSection,
  cardMusiciansSection,
  cardSmokingSection,
  cardSonaSection,
  cardVideoSection,
  cardVideoSliderSection,
  cardWithTableCompareSection,
  centerCardSection,
  collapsibleProductGridSection,
  ecoSection,
  faqGridSection,
  faqSection,
  findAnswerSection,
  freestyleImgGridSection,
  freestyleImgWithTextSection,
  freestyleTextSection,
  headingSection,
  iconWithTextSection,
  iconWithTextSliderSection,
  marqueeBasicTextSection,
  mokaSection,
  productGridSection,
  productReviewsSection,
  reviewGridKindLokalSection,
  reviewGridSection,
  reviewInfiniteMarqueeSection,
  satelliteSection,
  shakeriSection,
  subscribeEmailSection,
  textCarouselSection,
  textSurveySection,
  tinoGridSection,
  productReviewsSection02,
  productReviewsSection03,
  productReviewsSection04,
  marqueeTinoSection,
  marqueeImageSection,
  marqueeYuriSection,
  tabsSection,
  cardMediaSliderSection,
  cardMediaSliderSection02,
  cardMediaSliderSection03,
  cardFeeSizeImgSection,
  tableSection,
  reviewGridSection02,
  itemsGridSection,
  itemsGridSection02,
  cardStepInstructions,
  purchaseIncentiveSection,
  socialMediaSection,
  featuredOfferSection,
  postSection,
  cardReviewSection,
  cardStepSection,
  tableBenefitsComparison,
  bannerB1Section,
  itemsSlideB1Section,
  cardBasicB1Section,
  cardCompareB1Section,
  bannerBasicB1Section,
  tableSmallB1Section,
  iconWithTextB1Section,
  socialCommentSection,
  faqGridSection02,
  cardFeatureSection,
  cardReviewSection02,
  cardMediaSection,
  cardKeyFeaturesSection,
  faqGridSection03,
  imageWithTextBasicSection,
  reviewGridSection03,
  faqCardSection,
  bannerMediaSection,
  cardCompareYuriSection,
  cardTimelineYuriSection,
  cardSliderYuriSection,
  cardStatisticsYuriSection,
  reviewSliderYuriSection,
  faqGridSection04,
  cardMultiToolSection,
  cardMultiToolYuriSection,
  cardMultiToolDoubleSection,
  fbPost03Section,
  markqueueRowsSection,
  tableMultiToolSection,
  reviewTitanSection,
  textWithButtonSection,
  faqVitalSection,
  cardVitalSliderSection,
  cardVitalSlider02Section,
  cardVitalSurroundSection,
  cardVitalTabSection,
  productReviewsSection05,
  fastvaluedealReviewsSection,
  cardCompareProductSection,
  faqGridSection05,
  itemsGridSection03,
  itemsGridSection04,
  reviewGridSection04,
  reviewGridSection05,
  itemsGridSection05,
  itemsGridSection06,
  cardBasicSection,
  itemsGridMediaSection,
  cardStepInstructions02,
  bannerBasicSection,
  bannerFastvaluedealSection,
  cardBannerRivoneedSection,
  cardBanner02RivoneedSection,
  cardSatelliteRivoneedSection,
  cardWithSliderRivoneedSection,
  cardGridItemRivoneedSection,
  cardSliderRivoneedSection,
  marqueeRivoneedSection,
  cardBasicRivoneedSection,
  cardBadgeRivoneedSection,
  cardFaqRivoneedSection,
  cardBannerGatorzSection,
  cardGatorzCustomSection,
  cardGatorzGridItemSection,
  freestyleInfoSection,
  productReviewsSection06,
  reviewVitalSection,
  faqGridSection06,
  moneyBackGuaranteeSection,
  cardFastvaluedealTitleImgSection,
  sliderFastvaluedeal01Section,
  fastvaluedealCountdownSection,
  fastvaluedealCtaSection,
  fastvaluedealFaqSection,
  fastvaluedealMoneyBackGuaranteeSection,
  fastvaluedealReviewerSection,
  fastvaluedealCardBasicSection,
  fastvaluedealCardStepSection,
  fastvaluedealCompareBenefitsSection,
  fastvaluedealTableSection,
  gatorzYoutubeSection,
  gatorzCompareImageSection,
  gatorzReviewsSection,
  saintbrandReviewsSection,
  gatorzSupportSection,
  gatorzFrameSpecsSection,
  gatorzPolicySection,
  saintbrandInfiniteMarqueeSection,
  markqueueOrthopedicSection,
  orthopedicFeaturesGridSection,
  orthopedicCardFeaturesSection,
  orthopedicCardReviewSection,
  orthopedicCardBasicSection,
  losaprilyReviewsSection,
  losaprilyImagesGridSection,
  sowhatbuyCardBasicSection,
  sowhatbuyGuaranteeMarqueeSection,
  sowhatbuyFeaturesSliderSection,
  sowhatbuyRewardSection,
  sowhatbuyCardImageSection,
  cardMediaWithSliderLosaprilySection,
  cardTabWithContentLosaprilySection,
  losaprilyCardBannerSection,
  marqueeShopzovyaSection,
  cardBannerSowhatbuySection,
  cardItemsSowhatbuySection,
  cardCompareSowhatbuySection,
  tryherReviewGrid,
  tryherGridPercent,
  tryherTimeline,
  tryherCardCompare,
  tryherCardBasic,
  konfortifyCardBasic,
  imageWithTextCol1Section,
  sideBySideGridIconSection,
  cedrowFreetypeContentSection,
  cardCedrowWithTabSection,
  cardCedrowSideBySideSection,
  cardCedrowWithTabelSection,
  cardCedrowGridIconsSection,
  upairyTabs,
  upairyTimeline,
  upairyCard,
  upairyCompareCard,
  konfortifyFbSection,
  konfortifyBanner,
  konfortifyReviewGrid,
  furnitureshopBanner,
  furnitureshopCardStep,
  furnitureshopGridSlider,
  furnitureshopGridSlider02,
  furnitureshopSpecification,
  furnitureshopCarousel,
  furnitureshopReward,
  furnitureshopBanner02,
  furnitureshopBanner03,
  furnitureshopFaq,
  feetscareListImageSection,
  feetscareListItemSection,
  feetscareStatSection,
  feetscareSatelliteSection,
  manchestoreCompareSlider,
  manchestoreBanner,
  sofyreTabsReviewSection,
  sofyreTimeline,
  sofyreIngredients,
  sofyreUserManual,
  sofyreComparisonSection,
} from '@/section-templates/description';
import {
  countdownSection,
  freestyleHurrybox,
  hurryboxYuriSection,
  sizingChartSection,
  saintbrandFeaturesGridSection,
  madamSizeCalculatorSection,
  eskiinHurryboxSection,
} from '@/section-templates/hurrybox';
import {
  guaranteedSafeCheckoutSection,
  guaranteedSafeCheckoutSection02,
  orderInfoSection,
  freestyleOrderPolicySection,
  trustBadgeSection,
  policyAccordionBasicSection,
  policyYuriAccordionSection,
  policyYuriListSection,
  policyYuriVideosSection,
  policyYuriReivewSection,
  saintbrandShippingSection,
  leonieandcoReviewGrid,
  cardCedrowBenefitsPolicySection,
  eskiinPolicySection,
} from '@/section-templates/order-policy';
import { sectionType } from '@/views/website/products/components/description/common/types';

export const TplType = {
  Tabs: 'tabs',
  CardWithRating: 'card-with-rating',
  CardWithSurvey: 'card-with-survey',
  CardMultiTool: 'card-multi-tool',
  CardMultiToolDouble: 'card-multi-tool-double',
  CardWithContainer: 'card-with-container',
  CardDualImg: 'card-dual-img',
  CardCompareTwoImage: 'card-compare-two-image',
  CardStepInstructions: 'card-step-instructions',
  CardMedia: 'card-media',
  CardTimeline: 'card-timeline',
  Basic: 'card-basic',
  IconsWithText: 'icons-with-text',
  FaqAccordion: 'faq-accordion',
  FaqCard: 'faq-card',
  SurroundItems: 'surround-items',
  ProductGrid: 'product-grid',
  FreeLayout: 'free-layout',
  FreeLayoutHurryBox: 'free-layout-hurry-box',
  textCarousel: 'text-carousel',
  markQueue: 'mark-queue',
  cardCarousel: 'card-carousel',
  reviewGrid: 'review-grid',
  productReviews: 'product-reviews',
  bannerSlider: 'banner-slider',
  bannerMedia: 'banner-media',
  cardKeyFeatures: 'card-key-features',
  guaranteedSafeCheckout: 'guaranteed-safe-checkout',
  orderInfo: 'order-info',
  freestyleOrderPolicy: 'freestyle-order-policy',
  other: 'other',
  cardCTA: 'card-cta',
  table: 'table',
  gemPage: 'gem-page',
  ItemsGridMedia: 'items-grid-media',
};
export default {
  data() {
    return {
      activeItem: 'All templates',
      activeGroup: null,
      categoryTpl: [
        {
          action: 'mdi-file-multiple',
          active: true,
          title: 'All templates',
        },
        {
          action: 'mdi-card',
          items: [
            { title: 'Card basic', tplType: TplType.Basic },
            { title: 'Card with rating', tplType: TplType.CardWithRating },
            { title: 'Card with survey', tplType: TplType.CardWithSurvey },
            { title: 'Card with container', tplType: TplType.CardWithContainer },
            { title: 'Card dual image', tplType: TplType.CardDualImg },
            { title: 'Card compare two image', tplType: TplType.CardCompareTwoImage },
            { title: 'Card step instructions', tplType: TplType.CardStepInstructions },
            { title: 'Card media', tplType: TplType.CardMedia },
            { title: 'Card multi tool', tplType: TplType.CardMultiTool },
            { title: 'Card multi tool double', tplType: TplType.CardMultiToolDouble },
            { title: 'Card with tab', tplType: TplType.Tabs },
            { title: 'Card timeline', tplType: TplType.CardTimeline },
            { title: 'Other', tplType: TplType.other },
          ],
          title: 'Card',
        },
        {
          action: 'mdi-table',
          items: [{ title: 'Table basic', tplType: TplType.table }],
          title: 'Table',
        },
        {
          action: 'mdi-image-area',
          items: [
            { title: 'Banner slider', tplType: TplType.bannerSlider },
            { title: 'Banner media', tplType: TplType.bannerMedia },
          ],
          title: 'Banner',
        },
        {
          action: 'mdi-view-carousel-outline',
          items: [
            { title: 'Text carousel', tplType: TplType.textCarousel },
            { title: 'Card carousel', tplType: TplType.cardCarousel },
            { title: 'Mark queue', tplType: TplType.markQueue },
          ],
          title: 'Carousel',
        },
        {
          action: 'mdi-image-text',
          //   active: true,
          items: [{ title: 'Icons with text', tplType: TplType.IconsWithText }],
          title: 'Image with text',
        },
        {
          action: 'mdi-account-question',
          items: [
            { title: 'Faq accordion', tplType: TplType.FaqAccordion },
            { title: 'Faq card', tplType: TplType.FaqCard },
          ],
          title: 'Faq',
        },
        {
          action: 'mdi-format-wrap-square',
          items: [{ title: 'Surround items', tplType: TplType.SurroundItems }],
          title: 'Surround',
        },
        {
          action: 'mdi-view-grid',
          items: [
            { title: 'Product grid', tplType: TplType.ProductGrid },
            { title: 'Grid media', tplType: TplType.ItemsGridMedia },
          ],
          title: 'Grid items',
        },
        {
          action: 'mdi-format-line-style',
          items: [{ title: 'Free layout', tplType: TplType.FreeLayout }],
          title: 'Freestyle',
        },
        {
          action: 'mdi-star',
          items: [
            { title: 'Review Grid', tplType: TplType.reviewGrid },
            { title: 'Review List', tplType: TplType.productReviews },
          ],
          title: 'Review',
        },
        {
          action: 'mdi-arrow-top-right-thick',
          items: [{ title: 'Card CTA', tplType: TplType.cardCTA }],
          title: 'Purchase Incentive',
        },
        {
          action: 'mdi-gamepad-variant',
          items: [{ title: 'Gem Page', tplType: TplType.gemPage }],
          title: 'Gem Page',
        },
        {
          action: 'mdi-text-box-outline',
          items: [{ title: 'Free layout HurryBox', tplType: TplType.FreeLayoutHurryBox }],
          title: 'HurryBox',
        },
        {
          action: 'mdi-package-variant',
          items: [
            { title: 'Order Info', tplType: TplType.orderInfo },
            { title: 'Guaranteed Safe Checkout', tplType: TplType.guaranteedSafeCheckout },
            { title: 'Policy Accordion Basic', tplType: TplType.orderInfo },
            { title: 'Freestyle Order Policy', tplType: TplType.freestyleOrderPolicy },
          ],
          title: 'Order Policy',
        },
      ],
      sectionTemplates: [
        //moka card s
        {
          id: sectionType.sectionCustomizeCard,
          title: 'Moka Section',
          tplType: TplType.CardWithRating,
          type: sectionType.sectionCustomizeCard,
          html: `<section data-enable-anchor="false" data-enable-anchor="true" data-section="${sectionType.sectionCustomizeCard}-jhd0dv" data-type="${sectionType.sectionCustomizeCard}" data-title="Moka Section" data-attribute="section-title">
                ${mokaSection}
            </section>`,
          image: moka,
        },
        //eco card
        {
          id: sectionType.sectionCustomizeCard,
          title: 'Eco Section',
          tplType: TplType.Basic,
          type: sectionType.sectionCustomizeCard,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCustomizeCard}-6r48va" data-type="${sectionType.sectionCustomizeCard}" data-title="Eco Section" data-attribute="section-title">
                ${ecoSection}
            </section>`,
          image: eco,
        },
        //shakeri
        {
          id: sectionType.sectionCardWithSurvey,
          title: 'Shakeri Section',
          tplType: TplType.CardWithSurvey,
          type: sectionType.sectionCardWithSurvey,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardWithSurvey}-dya2l3" data-type="${sectionType.sectionCardWithSurvey}" data-title="Shakeri Section" data-attribute="section-title">
                ${shakeriSection}
            </section>`,
          image: shakeri,
        },
        //advanced-card
        {
          id: sectionType.sectionCustomizeCard,
          title: 'Advanced Card Section',
          tplType: TplType.CardWithContainer,
          type: sectionType.sectionCustomizeCard,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCustomizeCard}-5lymjz" data-type="${sectionType.sectionCustomizeCard}" data-title="Advanced Card Section" data-attribute="section-title">
                ${advancedSection}
            </section>`,
          image: advancedCard,
        },
        //centerCentent
        {
          id: sectionType.sectionCustomizeCard,
          title: 'Center Card Section',
          tplType: TplType.Basic,
          type: sectionType.sectionCustomizeCard,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCustomizeCard}-0dtmhw" data-type="${sectionType.sectionCustomizeCard}" data-title="Center Card Section" data-attribute="section-title">
             ${centerCardSection}
            </section>`,
          image: centerCentent,
        },
        //centerCentent viewmore
        // {
        //   id: sectionType.sectionCardHaveViewMore,
        //   title: 'Card Accordion Section',
        //   tplType: TplType.Basic,
        //   type: sectionType.sectionCardHaveViewMore,
        //   html: `<section data-section="${sectionType.sectionCardHaveViewMore}-0dtmhw" data-type="${sectionType.sectionCardHaveViewMore}" data-title="Card Accordion Section" data-attribute="section-title">
        //      ${cardHaveViewMoreSection}
        //     </section>`,
        //   image: cardViewMoreSection,
        // },
        {
          id: sectionType.sectionCardAccordions,
          title: 'Card Accordions Section',
          tplType: TplType.Basic,
          type: sectionType.sectionCardAccordions,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardAccordions}-0dtmhw" data-type="${sectionType.sectionCustomizeCard}" data-title="Card Accordions Section" data-attribute="section-title">
             ${cardAccordionsSection}
            </section>`,
          image: cardAccordionsImg,
        },
        {
          id: sectionType.sectionCardFeature,
          title: 'Card Feature Section',
          tplType: TplType.Basic,
          type: sectionType.sectionCardFeature,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardFeature}-0dtmhw" data-type="${sectionType.sectionCardFeature}" data-title="Card Feature Section" data-attribute="section-title">
             ${cardFeatureSection}
            </section>`,
          image: cardFeatureSectionImg,
        },
        {
          id: sectionType.sectionCardKeyFeatures,
          title: 'Card Key Features Section',
          type: sectionType.sectionCardKeyFeatures,
          tplType: TplType.Basic,
          html: `<section data-section="${sectionType.sectionCardKeyFeatures}-dwd2s" data-type="${sectionType.sectionCardKeyFeatures}" data-title="Card Key Features Section" data-attribute="section-title">
                ${cardKeyFeaturesSection}
            </section>`,
          image: cardKeyFeaturesImg,
        },
        {
          id: sectionType.sectionCardStepInstructions,
          title: 'Card Step Instructions Section',
          type: sectionType.sectionCardStepInstructions,
          tplType: TplType.CardStepInstructions,
          html: `<section data-section="${sectionType.sectionCardStepInstructions}-dwd2s" data-type="${sectionType.sectionCardStepInstructions}" data-title="Card Step Instructions Section" data-attribute="section-title">
                ${cardStepInstructions}
            </section>`,
          image: cardStepInstructionsImg,
        },
        {
          id: sectionType.sectionCardStepInstructions02,
          title: 'Card Step Instructions 02 Section',
          type: sectionType.sectionCardStepInstructions02,
          tplType: TplType.CardStepInstructions,
          html: `<section data-section="${sectionType.sectionCardStepInstructions02}-dwd2s" data-type="${sectionType.sectionCardStepInstructions02}" data-title="Card Step Instructions Section" data-attribute="section-title">
                ${cardStepInstructions02}
            </section>`,
          image: cardStepInstructions02Img,
        },
        {
          id: sectionType.sectionCardMedia,
          title: 'Card Media Section',
          type: sectionType.sectionCardMedia,
          tplType: TplType.CardMedia,
          html: `<section data-section="${sectionType.sectionCardMedia}-dwd2s" data-type="${sectionType.sectionCardMedia}" data-title="Card Media Section" data-attribute="section-title">
                ${cardMediaSection}
            </section>`,
          image: cardMediaImg,
        },
        // freestyle
        {
          id: sectionType.sectionFreestyle,
          title: 'Freestyle Section',
          type: sectionType.sectionFreestyle,
          tplType: TplType.FreeLayout,
          html: `<section class="ck-content" data-enable-anchor="false" data-section="${sectionType.sectionFreestyle}-4utqgg" data-type="${sectionType.sectionFreestyle}" data-title="Freestyle">
            ${freestyleTextSection}
          </section>`,
          image: freestyle,
        },
        {
          id: sectionType.sectionFreestyle,
          title: 'Freestyle Img Grid Section',
          type: sectionType.sectionFreestyle,
          tplType: TplType.FreeLayout,
          html: `<section class="ck-content" data-enable-anchor="false" data-section="${sectionType.sectionFreestyle}-4utqgg" data-type="${sectionType.sectionFreestyle}" data-title="Freestyle Img Grid Section">
            ${freestyleImgGridSection}
          </section>`,
          image: freestyleImgGrid,
        },
        // freestyle - img with text
        {
          id: sectionType.sectionFreestyle,
          title: 'Freestyle Image With Text',
          type: sectionType.sectionFreestyle,
          tplType: TplType.FreeLayout,
          html: `<section class="ck-content" data-enable-anchor="false" data-section="${sectionType.sectionFreestyle}-wsuz1e" data-type="${sectionType.sectionFreestyle}" data-title="Freestyle Image with text">
                ${freestyleImgWithTextSection}
           </section>`,
          image: freestyleImgText,
        },
        {
          id: sectionType.sectionFreestyleInfo,
          title: 'Freestyle Info Section',
          type: sectionType.sectionFreestyleInfo,
          tplType: TplType.FreeLayout,
          html: `<section class="ck-content" data-enable-anchor="false" data-section="${sectionType.sectionFreestyleInfo}-wsuz1e" data-type="${sectionType.sectionFreestyleInfo}" data-title="Freestyle Info Section">
                ${freestyleInfoSection}
           </section>`,
          image: freestyleInfoSectionImg,
        },
        //product grid
        {
          id: sectionType.sectionProductGrid,
          title: 'Product Grid Section',
          type: sectionType.sectionProductGrid,
          tplType: TplType.ProductGrid,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionProductGrid}-jeie9u" data-type="${sectionType.sectionProductGrid}" data-title="Section Grid Product" data-attribute="section-title">
            ${productGridSection}
            </section>`,
          image: productGrid,
        },
        //Surround
        {
          id: sectionType.sectionSatelliteGrid,
          title: 'Satellite Grid Section',
          tplType: TplType.SurroundItems,
          type: sectionType.sectionSatelliteGrid,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionSatelliteGrid}-hi1zkp" data-type="${sectionType.sectionSatelliteGrid}" data-title="Section Grid Satellite" data-attribute="section-title">
            ${satelliteSection}
            </section>`,
          image: satelliteGrid,
        },
        //Faq
        {
          id: sectionType.sectionQuestionFaq,
          title: 'Question Faq Section',
          tplType: TplType.FaqAccordion,
          type: sectionType.sectionQuestionFaq,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionQuestionFaq}-rzsk1x" data-type="${sectionType.sectionQuestionFaq}" data-title="Section Question FAQ" data-attribute="section-title">
            ${faqSection}
            </section>`,
          image: questionFaq,
        },
        //Image with text
        {
          id: sectionType.sectionIconWithText,
          title: 'Section Icon With Text',
          tplType: TplType.IconsWithText,
          type: sectionType.sectionIconWithText,
          image: iconwtext,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionIconWithText}-o76cxz" data-type="${sectionType.sectionIconWithText}" data-title="Section Icon With Text" data-attribute="section-title">
            ${iconWithTextSection}
            </section>`,
        },
        {
          id: sectionType.sectionImageWithTextBasic,
          title: 'Section Image With Text Basic',
          tplType: TplType.IconsWithText,
          type: sectionType.sectionImageWithTextBasic,
          image: imageWithTextBasicImg,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionImageWithTextBasic}-o76cxz" data-type="${sectionType.sectionImageWithTextBasic}" data-title="Section Image With Text Basic" data-attribute="section-title">
            ${imageWithTextBasicSection}
            </section>`,
        },
        //card dual imgae
        {
          id: sectionType.sectionCardDualImg,
          title: 'Card Dual Image',
          tplType: TplType.CardDualImg,
          type: sectionType.sectionCardDualImg,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardDualImg}-o76cxz" data-type="${sectionType.sectionCardDualImg}" data-title="Card Dual Image" data-attribute="section-title">
            ${cardDualImageSection}
            </section>`,
          image: cardDualImg,
        },
        {
          id: sectionType.sectionFindAnswer,
          title: 'Find Answer Section',
          tplType: TplType.FaqAccordion,
          type: sectionType.sectionFindAnswer,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionFindAnswer}-o76cxz" data-type="${sectionType.sectionFindAnswer}" data-title="Find Answer Section" data-attribute="section-title">
            ${findAnswerSection}
            </section>`,
          image: findAnswer,
        },
        {
          id: sectionType.sectionTextCarousel,
          title: 'Text Carousel Section',
          tplType: TplType.textCarousel,
          type: sectionType.sectionTextCarousel,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionTextCarousel}-o76cxz" data-type="${sectionType.sectionTextCarousel}" data-title="Text Carousel Section" data-attribute="section-title">
            ${textCarouselSection}
            </section>`,
          image: textCarousel,
        },
        {
          id: sectionType.sectionHeading,
          title: 'Heading Section',
          tplType: TplType.other,
          type: sectionType.sectionHeading,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionHeading}-sdsdsd" data-type="${sectionType.sectionHeading}" data-title="Heading Section" data-attribute="section-title">
            ${headingSection}
            </section>`,
          image: headingText,
        },
        {
          id: sectionType.sectionCardSmoking,
          title: 'Card Smoking Section',
          tplType: TplType.other,
          type: sectionType.sectionCardSmoking,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardSmoking}-sdsdsd" data-type="${sectionType.sectionCardSmoking}" data-title="Card Smoking Section" data-attribute="section-title">
            ${cardSmokingSection}
            </section>`,
          image: cardSmoking,
        },
        {
          id: sectionType.sectionCardSmoking,
          title: 'Card Musicians Section',
          tplType: TplType.other,
          type: sectionType.sectionCardSmoking,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardSmoking}-sdsdsd" data-type="${sectionType.sectionCardSmoking}" data-title="Card Musicians Section" data-attribute="section-title">
            ${cardMusiciansSection}
            </section>`,
          image: cardMusicians,
        },
        //review grid
        {
          id: sectionType.sectionReviewGridSection03,
          title: 'Review Grid Section 03',
          tplType: TplType.reviewGrid,
          type: sectionType.sectionReviewGridSection03,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionReviewGridSection03}-o76cxz" data-type="${sectionType.sectionReviewGridSection03}" data-title="Review Grid Section 03" data-attribute="section-title">
              ${reviewGridSection03}
          </section>`,
          image: reviewGridSection03Img,
        },
        {
          id: sectionType.sectionReviewGrid,
          title: 'Review Grid Section',
          tplType: TplType.reviewGrid,
          type: sectionType.sectionReviewGrid,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionReviewGrid}-o76cxz" data-type="${sectionType.sectionReviewGrid}" data-title="Review Grid Section" data-attribute="section-title">
              ${reviewGridSection}
          </section>`,
          image: reviewGridImage,
        },
        {
          id: sectionType.sectionReviewGrid02,
          title: 'Review Grid Section 02',
          tplType: TplType.reviewGrid,
          type: sectionType.sectionReviewGrid02,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionReviewGrid02}-o76cxz" data-type="${sectionType.sectionReviewGrid02}" data-title="Review Grid Section 02" data-attribute="section-title">
              ${reviewGridSection02}
          </section>`,
          image: reviewGridImage02,
        },
        {
          id: sectionType.sectionReviewGridKindLokal,
          title: 'Review Grid Kind Lokal Section',
          tplType: TplType.reviewGrid,
          type: sectionType.sectionReviewGridKindLokal,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionReviewGridKindLokal}-o76cxz" data-type="${sectionType.sectionReviewGridKindLokal}" data-title="Review Grid Kind Lokal Section" data-attribute="section-title">
              ${reviewGridKindLokalSection}
          </section>`,
          image: reviewGridKindLokalImage,
        },
        {
          id: sectionType.sectionReviewInfiniteMarquee,
          title: 'Review Infinite Marquee',
          tplType: TplType.reviewGrid,
          type: sectionType.sectionReviewInfiniteMarquee,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionReviewInfiniteMarquee}-o76cxz" data-type="${sectionType.sectionReviewInfiniteMarquee}" data-title="Review Infinite Marquee" data-attribute="section-title">
              ${reviewInfiniteMarqueeSection}
          </section>`,
          image: reviewInfiniteMarqueeImg,
        },
        {
          id: sectionType.sectionReviewGrid04,
          title: 'Review Grid Section 04',
          tplType: TplType.reviewGrid,
          type: sectionType.sectionReviewGrid04,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionReviewGrid04}-o76cxz" data-type="${sectionType.sectionReviewGrid04}" data-title="Review Grid Section 04" data-attribute="section-title">
              ${reviewGridSection04}
          </section>`,
          image: reviewGridSection04Img,
        },
        {
          id: sectionType.sectionReviewGrid05,
          title: 'Review Grid Section 05',
          tplType: TplType.reviewGrid,
          type: sectionType.sectionReviewGrid05,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionReviewGrid05}-dwd2" data-type="${sectionType.sectionReviewGrid05}" data-title="Review Grid Section 05" data-attribute="section-title">
                ${reviewGridSection05}
            </section>`,
          image: reviewGridSection05Img,
        },
        //product review
        {
          id: sectionType.sectionProductReviews,
          title: 'Product Reviews Section',
          tplType: TplType.productReviews,
          type: sectionType.sectionProductReviews,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionProductReviews}-o76cxz" data-type="${sectionType.sectionProductReviews}" data-title="Product Reviews Section" data-attribute="section-title">
            ${productReviewsSection}
          </section>`,
          image: productReviewsImage,
        },
        {
          id: sectionType.sectionProductReviews02,
          title: 'Product Reviews Section 2',
          tplType: TplType.productReviews,
          type: sectionType.sectionProductReviews02,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionProductReviews02}-o76cxz" data-type="${sectionType.sectionProductReviews02}" data-title="Product Reviews Section 2" data-attribute="section-title">
              ${productReviewsSection02}
          </section>`,
          image: productReviewsSection02Img,
        },
        {
          id: sectionType.sectionProductReviews03,
          title: 'Product Reviews Section 3',
          tplType: TplType.productReviews,
          type: sectionType.sectionProductReviews03,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionProductReviews03}-o76cxz" data-type="${sectionType.sectionProductReviews03}" data-title="Product Reviews Section 3" data-attribute="section-title">
              ${productReviewsSection03}
          </section>`,
          image: productReviewsSection03Img,
        },
        {
          id: sectionType.sectionProductReviews04,
          title: 'Product Reviews Section 4',
          tplType: TplType.productReviews,
          type: sectionType.sectionProductReviews04,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionProductReviews04}-o76cxz" data-type="${sectionType.sectionProductReviews04}" data-title="Product Reviews Section 4" data-attribute="section-title">
              ${productReviewsSection04}
          </section>`,
          image: productReviewsSection04Img,
        },
        {
          id: sectionType.sectionProductReviews05,
          title: 'Product Reviews Section 5',
          tplType: TplType.productReviews,
          type: sectionType.sectionProductReviews05,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionProductReviews05}-o76cxz" data-type="${sectionType.sectionProductReviews05}" data-title="Product Reviews Section 5" data-attribute="section-title">
              ${productReviewsSection05}
          </section>`,
          image: productReviewsSection05Img,
        },
        {
          id: sectionType.sectionProductReviews06,
          title: 'Product Reviews Section 6',
          tplType: TplType.productReviews,
          type: sectionType.sectionProductReviews06,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionProductReviews06}-o76cxz" data-type="${sectionType.sectionProductReviews06}" data-title="Product Reviews Section 6" data-attribute="section-title">
              ${productReviewsSection06}
          </section>`,
          image: productReviewsSection06Img,
        },
        {
          id: sectionType.sectionFastvaluedealReviews,
          title: 'Fastvaluedeal Reviews Section',
          tplType: TplType.productReviews,
          type: sectionType.sectionFastvaluedealReviews,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionFastvaluedealReviews}-o76cxz" data-type="${sectionType.sectionFastvaluedealReviews}" data-title="Fastvaluedeal Reviews Section" data-attribute="section-title">
              ${fastvaluedealReviewsSection}
          </section>`,
          image: fastvaluedealReviewsSectionImg,
        },
        {
          id: sectionType.marqueeBasicText,
          title: 'Marquee Basic Text Section',
          tplType: TplType.textCarousel,
          type: sectionType.sectionMarqueeBasicText,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionMarqueeBasicText}-o76cxz" data-type="${sectionType.sectionMarqueeBasicText}" data-title="Marquee Basic Text Section" data-attribute="section-title">
              ${marqueeBasicTextSection}
          </section>`,
          image: marqueeBasicText,
        },
        {
          id: sectionType.sectionTextSurvey,
          title: 'Text Survey Section',
          tplType: TplType.CardWithSurvey,
          type: sectionType.sectionTextSurvey,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionTextSurvey}-sds2" data-type="${sectionType.sectionTextSurvey}" data-title="Text Survey Section" data-attribute="section-title">
              ${textSurveySection}
          </section>`,
          image: textSurvey,
        },
        {
          id: sectionType.sectionCompareTwoImg,
          title: 'Card Compare Two Image Section',
          tplType: TplType.CardCompareTwoImage,
          type: sectionType.sectionCompareTwoImg,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCompareTwoImg}-sdss2sd" data-type="${sectionType.sectionCompareTwoImg}" data-title="Card Compare Two Image Section" data-attribute="section-title">
              ${cardCompareTwoImageSection}
          </section>`,
          image: cardCompareTwoImage,
        },
        {
          id: sectionType.sectionCardCompareYuri,
          title: 'Card Compare Yuri Section',
          tplType: TplType.CardCompareTwoImage,
          type: sectionType.sectionCardCompareYuri,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardCompareYuri}-sdss2sd" data-type="${sectionType.sectionCardCompareYuri}" data-title="Card Compare Yuri Section" data-attribute="section-title">
              ${cardCompareYuriSection}
          </section>`,
          image: cardCompareYuriSectionImg,
        },
        {
          id: sectionType.sectionCardTimelineYuri,
          title: 'Card Timeline Yuri Section',
          tplType: TplType.CardTimeline,
          type: sectionType.sectionCardTimelineYuri,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardTimelineYuri}-sdss2sd" data-type="${sectionType.sectionCardTimelineYuri}" data-title="Card Timeline Yuri Section" data-attribute="section-title">
              ${cardTimelineYuriSection}
          </section>`,
          image: cardTimelineYuriSectionImg,
        },
        {
          id: sectionType.sectionCardSliderYuri,
          title: 'Card Slider Yuri Section',
          tplType: TplType.cardCarousel,
          type: sectionType.sectionCardSliderYuri,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardSliderYuri}-sdss2sd" data-type="${sectionType.sectionCardSliderYuri}" data-title="Card Slider Yuri Section" data-attribute="section-title">
              ${cardSliderYuriSection}
          </section>`,
          image: cardSliderYuri02SectionImg,
        },
        {
          id: sectionType.sectionCardStatisticsYuri,
          title: 'Card Statistics Yuri Section',
          tplType: TplType.Basic,
          type: sectionType.sectionCardStatisticsYuri,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardStatisticsYuri}-sdss2sd" data-type="${sectionType.sectionCardStatisticsYuri}" data-title="Card Statistics Yuri Section" data-attribute="section-title">
              ${cardStatisticsYuriSection}
          </section>`,
          image: cardStatisticsYuriSectionImg,
        },
        {
          id: sectionType.sectionReviewSliderYuri,
          title: 'Review Slider Yuri Section',
          tplType: TplType.cardCarousel,
          type: sectionType.sectionReviewSliderYuri,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionReviewSliderYuri}-sdss2sd" data-type="${sectionType.sectionReviewSliderYuri}" data-title="Review Slider Yuri Section" data-attribute="section-title">
              ${reviewSliderYuriSection}
          </section>`,
          image: reviewSliderYuriSectionImg,
        },
        {
          id: sectionType.sectionCardWithTableCompare,
          title: 'Card With Table Compare Section',
          tplType: TplType.CardCompareTwoImage,
          type: sectionType.sectionCardWithTableCompare,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardWithTableCompare}-123hfg" data-type="${sectionType.sectionCardWithTableCompare}" data-title="Card With Table Compare Section" data-attribute="section-title">
              ${cardWithTableCompareSection}
          </section>`,
          image: cardWithTableCompareImg,
        },
        //banner slider
        {
          id: sectionType.sectionBannerSlider,
          title: 'Banner Slider Section',
          tplType: TplType.bannerSlider,
          type: sectionType.sectionBannerSlider,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionBannerSlider}-123hfg" data-type="${sectionType.sectionBannerSlider}" data-title="Banner Slider Section" data-attribute="section-title">
              ${bannerSliderSection}
          </section>`,
          image: bannerSliderImg,
        },
        {
          id: sectionType.sectionBannerB1,
          title: 'Banner B1 Section',
          tplType: TplType.bannerMedia,
          type: sectionType.sectionBannerB1,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionBannerB1}-123hfg" data-type="${sectionType.sectionBannerB1}" data-title="Banner Slider Section" data-attribute="section-title">
              ${bannerB1Section}
          </section>`,
          image: bannerB1SectionImg,
        },
        {
          id: sectionType.sectionBannerMedia,
          title: 'Banner Media Section',
          tplType: TplType.bannerMedia,
          type: sectionType.sectionBannerMedia,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionBannerMedia}-123hfg" data-type="${sectionType.sectionBannerMedia}" data-title="Banner Media Section" data-attribute="section-title">
              ${bannerMediaSection}
          </section>`,
          image: bannerMediaImg,
        },
        {
          id: sectionType.sectionGatorzYoutube,
          title: 'Gatorz Youtube',
          tplType: TplType.bannerMedia,
          type: sectionType.sectionGatorzYoutube,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionGatorzYoutube}-123hfg" data-type="${sectionType.sectionGatorzYoutube}" data-title="Gatorz Youtube" data-attribute="section-title">
              ${gatorzYoutubeSection}
          </section>`,
          image: gatorzYoutubeSectionImg,
        },
        {
          id: sectionType.sectionGatorzCompareImage,
          title: 'Gatorz Compare Image',
          tplType: TplType.CardCompareTwoImage,
          type: sectionType.sectionGatorzCompareImage,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionGatorzCompareImage}-123hfg" data-type="${sectionType.sectionGatorzCompareImage}" data-title="Gatorz Compare Image" data-attribute="section-title">
              ${gatorzCompareImageSection}
          </section>`,
          image: gatorzCompareImageSectionImg,
        },
        {
          id: sectionType.sectionGatorzReviews,
          title: 'Gatorz Reviews',
          tplType: TplType.productReviews,
          type: sectionType.sectionGatorzReviews,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionGatorzReviews}-o76cxz" data-type="${sectionType.sectionGatorzReviews}" data-title="Gatorz Reviews" data-attribute="section-title">
              ${gatorzReviewsSection}
          </section>`,
          image: gatorzReviewsSectionImg,
        },
        {
          id: sectionType.sectionSaintbrandReviews,
          title: 'Saintbrand Reviews',
          tplType: TplType.productReviews,
          type: sectionType.sectionSaintbrandReviews,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionSaintbrandReviews}-sb7rvw" data-type="${sectionType.sectionSaintbrandReviews}" data-title="Saintbrand Reviews" data-attribute="section-title">
              ${saintbrandReviewsSection}
          </section>`,
          image: saintbrandReviewsSectionImg,
        },
        {
          id: sectionType.sectionLosaprilyReviews,
          title: 'Losaprily Reviews',
          tplType: TplType.productReviews,
          type: sectionType.sectionLosaprilyReviews,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionLosaprilyReviews}-lp9rvw" data-type="${sectionType.sectionLosaprilyReviews}" data-title="Losaprily Reviews" data-attribute="section-title">
              ${losaprilyReviewsSection}
          </section>`,
          image: losaprilyReviewsSectionImg,
        },
        {
          id: sectionType.sectionGatorzSupport,
          title: 'Gatorz Support',
          tplType: TplType.ProductGrid,
          type: sectionType.sectionGatorzSupport,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionGatorzSupport}-sp8k2m" data-type="${sectionType.sectionGatorzSupport}" data-title="Gatorz Support" data-attribute="section-title">
              ${gatorzSupportSection}
          </section>`,
          image: gatorzSupportSectionImg,
        },
        {
          id: sectionType.sectionGatorzFrameSpecs,
          title: 'Gatorz Frame Specs',
          tplType: TplType.Basic,
          type: sectionType.sectionGatorzFrameSpecs,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionGatorzFrameSpecs}-fr8k1m" data-type="${sectionType.sectionGatorzFrameSpecs}" data-title="Gatorz Frame Specs" data-attribute="section-title">
              ${gatorzFrameSpecsSection}
          </section>`,
          image: gatorzFrameSpecsSectionImg,
        },
        {
          id: sectionType.sectionGatorzPolicy,
          title: 'Gatorz Policy',
          tplType: TplType.Basic,
          type: sectionType.sectionGatorzPolicy,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionGatorzPolicy}-pl9k3m" data-type="${sectionType.sectionGatorzPolicy}" data-title="Gatorz Policy" data-attribute="section-title">
              ${gatorzPolicySection}
          </section>`,
          image: gatorzPolicySectionImg,
        },
        {
          id: sectionType.sectionSaintbrandInfiniteMarquee,
          title: 'Saintbrand Infinite Marquee',
          tplType: TplType.reviewGrid,
          type: sectionType.sectionSaintbrandInfiniteMarquee,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionSaintbrandInfiniteMarquee}-sm8k4n" data-type="${sectionType.sectionSaintbrandInfiniteMarquee}" data-title="Saintbrand Infinite Marquee" data-attribute="section-title">
              ${saintbrandInfiniteMarqueeSection}
          </section>`,
          image: saintbrandInfiniteMarqueeSectionImg,
        },
        {
          id: sectionType.sectionIconWitTextSlider,
          title: 'Icon With Text Slider Section',
          tplType: TplType.IconsWithText,
          type: sectionType.sectionIconWitTextSlider,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionIconWitTextSlider}-sdsj2" data-type="${sectionType.sectionIconWitTextSlider}" data-title="Icon With Text Slider Section" data-attribute="section-title">
              ${iconWithTextSliderSection}
          </section>`,
          image: iconWithTextSliderImg,
        },
        {
          id: sectionType.sectionSubscribeEmail,
          title: 'Subcribe Email Section',
          tplType: TplType.other,
          type: sectionType.sectionSubscribeEmail,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionSubscribeEmail}-sdsj2" data-type="${sectionType.sectionSubscribeEmail}" data-title="Subcribe Email Section" data-attribute="section-title">
              ${subscribeEmailSection}
          </section>`,
          image: subscribeEmailImg,
        },
        {
          id: sectionType.sectionCardSona,
          title: 'Card Sona Section',
          tplType: TplType.Basic,
          type: sectionType.sectionCardSona,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardSona}-sdsj2" data-type="${sectionType.sectionCardSona}" data-title="Card Sona Section" data-attribute="section-title">
              ${cardSonaSection}
          </section>`,
          image: cardSonaImg,
        },
        {
          id: sectionType.sectionTinoGrid,
          title: 'Tino Grid Section',
          tplType: TplType.ProductGrid,
          type: sectionType.sectionTinoGrid,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionTinoGrid}-sdsj2" data-type="${sectionType.sectionTinoGrid}" data-title="Tino Grid Section" data-attribute="section-title">
              ${tinoGridSection}
          </section>`,
          image: tinoGridImg,
        },
        {
          id: sectionType.sectionFaqGrid,
          title: 'Faq Grid Section',
          tplType: TplType.FaqAccordion,
          type: sectionType.sectionFaqGrid,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionFaqGrid}-sdsj2" data-type="${sectionType.sectionFaqGrid}" data-title="Faq Grid Section" data-attribute="section-title">
              ${faqGridSection}
          </section>`,
          image: faqGridImg,
        },
        {
          id: sectionType.sectionFaqGrid02,
          title: 'Faq Grid Section 02',
          tplType: TplType.FaqAccordion,
          type: sectionType.sectionFaqGrid02,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionFaqGrid02}-sdsj2" data-type="${sectionType.sectionFaqGrid02}" data-title="Faq Grid Section 02" data-attribute="section-title">
              ${faqGridSection02}
          </section>`,
          image: faqGridImg02,
        },
        {
          id: sectionType.sectionFaqGrid03,
          title: 'Faq Grid Section 03',
          tplType: TplType.FaqAccordion,
          type: sectionType.sectionFaqGrid03,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionFaqGrid03}-sdsj2" data-type="${sectionType.sectionFaqGrid03}" data-title="Faq Grid Section 03" data-attribute="section-title">
              ${faqGridSection03}
          </section>`,
          image: faqGridImg03,
        },
        {
          id: sectionType.sectionFaqGrid04,
          title: 'Faq Grid Section 04',
          tplType: TplType.FaqAccordion,
          type: sectionType.sectionFaqGrid04,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionFaqGrid04}-sdsj2" data-type="${sectionType.sectionFaqGrid04}" data-title="Faq Grid Section 04" data-attribute="section-title">
              ${faqGridSection04}
          </section>`,
          image: faqGridImg04,
        },
        {
          id: sectionType.sectionFaqGrid05,
          title: 'Faq Grid Section 05',
          tplType: TplType.FaqAccordion,
          type: sectionType.sectionFaqGrid05,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionFaqGrid05}-sdsj2" data-type="${sectionType.sectionFaqGrid05}" data-title="Faq Grid Section 05" data-attribute="section-title">
              ${faqGridSection05}
          </section>`,
          image: faqGridImg05,
        },
        {
          id: sectionType.sectionFaqGrid06,
          title: 'Faq Grid Section 06',
          tplType: TplType.FaqAccordion,
          type: sectionType.sectionFaqGrid06,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionFaqGrid06}-sdsj2" data-type="${sectionType.sectionFaqGrid06}" data-title="Faq Grid Section 06" data-attribute="section-title">
              ${faqGridSection06}
          </section>`,
          image: faqGridImg06,
        },
        {
          id: sectionType.sectionFaqCard,
          title: 'Faq Card Section',
          tplType: TplType.FaqCard,
          type: sectionType.sectionFaqCard,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionFaqCard}-sdsj2" data-type="${sectionType.sectionFaqCard}" data-title="Faq Card Section" data-attribute="section-title">
              ${faqCardSection}
          </section>`,
          image: faqCardImg,
        },
        {
          id: sectionType.sectionCollapsibleProductGrid,
          title: 'Collapsible Product Grid Section',
          tplType: TplType.ProductGrid,
          type: sectionType.sectionCollapsibleProductGrid,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCollapsibleProductGrid}-jeie9u" data-type="${sectionType.sectionCollapsibleProductGrid}" data-title="Collapsible Product Grid Section" data-attribute="section-title">
              ${collapsibleProductGridSection}
          </section>`,
          image: collapsibleProductGridImg,
        },
        {
          id: sectionType.sectionCardVideoSlider,
          title: 'Card Video Slider Section',
          tplType: TplType.cardCarousel,
          type: sectionType.sectionCardVideoSlider,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardVideoSlider}-dwd2" data-type="${sectionType.sectionCardVideoSlider}" data-title="Card Video Slider Section" data-attribute="section-title">
                ${cardVideoSliderSection}
            </section>`,
          image: videoSliderImg,
        },
        {
          id: sectionType.sectionItemsSlideB1,
          title: 'Items Slide B1 Section',
          tplType: TplType.cardCarousel,
          type: sectionType.sectionItemsSlideB1,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionItemsSlideB1}-dwd2" data-type="${sectionType.sectionItemsSlideB1}" data-title="Items Slide B1 Section" data-attribute="section-title">
                ${itemsSlideB1Section}
            </section>`,
          image: itemsSlideB1SectionImg,
        },
        {
          id: sectionType.sectionCardMediaSlider,
          title: 'Card Media Slider Section',
          tplType: TplType.cardCarousel,
          type: sectionType.sectionCardMediaSlider,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardMediaSlider}-dwd2" data-type="${sectionType.sectionCardMediaSlider}" data-title="Card Media Slider Section" data-attribute="section-title">
                ${cardMediaSliderSection}
            </section>`,
          image: cardMediaSliderImg,
        },
        {
          id: sectionType.sectionCardMediaSlider02,
          title: 'Card Media Slider Section 02',
          tplType: TplType.cardCarousel,
          type: sectionType.sectionCardMediaSlider02,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardMediaSlider02}-dwd2" data-type="${sectionType.sectionCardMediaSlider02}" data-title="Card Media Slider Section 02" data-attribute="section-title">
                ${cardMediaSliderSection02}
            </section>`,
          image: cardMediaSlider02Img,
        },
        {
          id: sectionType.sectionCardMediaSlider03,
          title: 'Card Media Slider Section 03',
          tplType: TplType.cardCarousel,
          type: sectionType.sectionCardMediaSlider03,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardMediaSlider03}-dwd2" data-type="${sectionType.sectionCardMediaSlider03}" data-title="Card Media Slider Section 03" data-attribute="section-title">
                ${cardMediaSliderSection03}
            </section>`,
          image: cardMediaSlider03Img,
        },
        {
          id: sectionType.sectionCardFeeSizeImg,
          title: 'Card Fee Size Img Section',
          tplType: TplType.Basic,
          type: sectionType.sectionCardFeeSizeImg,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardFeeSizeImg}-dwd2" data-type="${sectionType.sectionCardFeeSizeImg}" data-title="Card Fee Size Img Section" data-attribute="section-title">
                ${cardFeeSizeImgSection}
            </section>`,
          image: cardFeeSizeImgImg,
        },
        {
          id: sectionType.sectionCardVideo,
          title: 'Card Video Section',
          tplType: TplType.CardBasic,
          type: sectionType.sectionCardVideo,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardVideo}-dwd2" data-type="${sectionType.sectionCardVideo}" data-title="Card Video Section" data-attribute="section-title">
                ${cardVideoSection}
            </section>`,
          image: videoImg,
        },
        {
          id: sectionType.sectionMarqueeTino,
          title: 'Marquee Tino Section',
          type: sectionType.sectionMarqueeTino,
          tplType: TplType.textCarousel,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionMarqueeTino}-dwd2" data-type="${sectionType.sectionMarqueeTino}" data-title="Marquee Tino Section" data-attribute="section-title">
                ${marqueeTinoSection}
            </section>`,
          image: marqueetinoImg,
        },
        {
          id: sectionType.sectionMarqueeImage,
          title: 'Marquee Image Section',
          type: sectionType.sectionMarqueeImage,
          tplType: TplType.textCarousel,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionMarqueeImage}-dwd2" data-type="${sectionType.sectionMarqueeImage}" data-title="Marquee Image Section" data-attribute="section-title">
                ${marqueeImageSection}
            </section>`,
          image: marqueeImageImg,
        },
        {
          id: sectionType.sectionMarqueeYuri,
          title: 'Marquee Yuri Section',
          type: sectionType.sectionMarqueeYuri,
          tplType: TplType.textCarousel,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionMarqueeYuri}-dwd2" data-type="${sectionType.sectionMarqueeYuri}" data-title="Marquee Yuri Section" data-attribute="section-title">
                ${marqueeYuriSection}
            </section>`,
          image: marqueeYuriSectionImg,
        },
        {
          id: sectionType.sectionMarqueeShopzovya,
          title: 'Marquee Shopzovya Section',
          type: sectionType.sectionMarqueeShopzovya,
          tplType: TplType.textCarousel,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionMarqueeShopzovya}-dwd2" data-type="${sectionType.sectionMarqueeShopzovya}" data-title="Marquee Shopzovya Section" data-attribute="section-title">
                ${marqueeShopzovyaSection}
            </section>`,
          image: shopzovyaMarqueeImage,
        },
        {
          id: sectionType.sectionTableKubo,
          title: 'Table Section',
          type: sectionType.sectionTableKubo,
          tplType: TplType.table,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionTableKubo}-dwd2s" data-type="${sectionType.sectionTableKubo}" data-title="Table Section" data-attribute="section-title">
                ${tableSection}
            </section>`,
          image: tableSectionImg,
        },
        {
          id: sectionType.sectionTpla,
          title: 'TPLA Section',
          type: sectionType.sectionTpla,
          tplType: TplType.table,
          html: this.wrapHtmlSection({
            type: sectionType.sectionTpla,
            temp: tableMultiToolSection,
            title: 'TPLA Section',
          }),
          image: tableMultiToolImg,
        },
        {
          id: sectionType.sectionReviewTitan,
          title: 'Review Titan Section',
          type: sectionType.sectionReviewTitan,
          tplType: TplType.reviewGrid,
          html: this.wrapHtmlSection({
            type: sectionType.sectionReviewTitan,
            temp: reviewTitanSection,
            title: 'Review Titan Section',
          }),
          image: reviewTitanImg,
        },
        {
          id: sectionType.sectionItemsGrid,
          title: 'Items Grid Section',
          type: sectionType.sectionItemsGrid,
          tplType: TplType.ProductGrid,
          // html: `<section data-section="${sectionType.sectionItemsGrid}-dwd2s" data-type="${sectionType.sectionItemsGrid}" data-title="Items Grid Section" data-attribute="section-title">
          //       ${itemsGridSection}
          //   </section>`,
          html: this.wrapHtmlSection({
            type: sectionType.sectionItemsGrid,
            temp: itemsGridSection,
            title: 'Items Grid Section',
          }),
          image: itemsGridSectionImg,
        },
        {
          id: sectionType.sectionItemsGrid02,
          title: 'Items Grid Section 02',
          type: sectionType.sectionItemsGrid02,
          tplType: TplType.ProductGrid,
          html: this.wrapHtmlSection({
            type: sectionType.sectionItemsGrid02,
            temp: itemsGridSection02,
            title: 'Items Grid Section 02',
          }),
          image: itemsGridSection02Img,
        },
        {
          id: sectionType.sectionItemsGrid03,
          title: 'Items Grid Section 03',
          type: sectionType.sectionItemsGrid03,
          tplType: TplType.ProductGrid,
          html: `<section class="ck-content" data-section="${sectionType.sectionItemsGrid03}-dwd2s" data-type="${sectionType.sectionItemsGrid03}" data-title="Items Grid Section 03" data-attribute="section-title">
                ${itemsGridSection03}
            </section>`,
          image: itemsGridSection03Img,
        },
        {
          id: sectionType.sectionItemsGrid04,
          title: 'Items Grid Section 04',
          type: sectionType.sectionItemsGrid04,
          tplType: TplType.ProductGrid,
          html: `<section class="ck-content" data-section="${sectionType.sectionItemsGrid04}-dwd2s" data-type="${sectionType.sectionItemsGrid04}" data-title="Items Grid Section 04" data-attribute="section-title">
                ${itemsGridSection04}
            </section>`,
          image: itemsGridSection04Img,
        },
        {
          id: sectionType.sectionItemsGrid05,
          title: 'Items Grid Section 05',
          tplType: TplType.ProductGrid,
          type: sectionType.sectionItemsGrid05,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionItemsGrid05}-o76cxz" data-type="${sectionType.sectionItemsGrid05}" data-title="Items Grid Section 05" data-attribute="section-title">
              ${itemsGridSection05}
          </section>`,
          image: itemsGridSection05Img,
        },
        {
          id: sectionType.sectionItemsGrid06,
          title: 'Items Grid Section 06',
          tplType: TplType.ProductGrid,
          type: sectionType.sectionItemsGrid06,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionItemsGrid06}-o76cxz" data-type="${sectionType.sectionItemsGrid06}" data-title="Items Grid Section 06" data-attribute="section-title">
              ${itemsGridSection06}
          </section>`,
          image: itemsGridSection06Img,
        },
        {
          id: sectionType.sectionItemsGridMedia,
          title: 'Items Grid Media Section',
          tplType: TplType.ItemsGridMedia,
          type: sectionType.sectionItemsGridMedia,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionItemsGridMedia}-o76cxz" data-type="${sectionType.sectionItemsGridMedia}" data-title="Items Grid Media Section" data-attribute="section-title">
              ${itemsGridMediaSection}
          </section>`,
          image: itemsGridMediaSectionImg,
        },
        {
          id: sectionType.sectionPurchaseIncentive,
          title: 'Purchase Incentive Section',
          type: sectionType.sectionPurchaseIncentive,
          tplType: TplType.cardCTA,
          html: `<section data-section="${sectionType.sectionPurchaseIncentive}-dwd2s" data-type="${sectionType.sectionPurchaseIncentive}" data-title="Purchase Incentive Section" data-attribute="section-title">
                ${purchaseIncentiveSection}
            </section>`,
          image: purchaseIncentiveImg,
        },
        {
          id: sectionType.sectionMoneyBackGuarantee,
          title: 'Money Back Guarantee Section',
          type: sectionType.sectionMoneyBackGuarantee,
          tplType: TplType.cardCTA,
          html: `<section data-section="${sectionType.sectionMoneyBackGuarantee}-dwd2s" data-type="${sectionType.sectionMoneyBackGuarantee}" data-title="Money Back Guarantee Section" data-attribute="section-title">
                ${moneyBackGuaranteeSection}
            </section>`,
          image: moneyBackGuaranteeSectionImg,
        },
        {
          id: sectionType.sectionCardReview02,
          title: 'Card Review Section 02',
          type: sectionType.sectionCardReview02,
          tplType: TplType.cardCTA,
          html: `<section data-section="${sectionType.sectionCardReview02}-dwd2s" data-type="${sectionType.sectionCardReview02}" data-title="Card Review Section 02" data-attribute="section-title">
                ${cardReviewSection02}
            </section>`,
          image: cardReview02Img,
        },
        {
          id: sectionType.sectionPost,
          title: 'Post Section',
          type: sectionType.sectionPost,
          tplType: TplType.gemPage,
          html: `<section data-section="${sectionType.sectionPost}-dwd2s" data-type="${sectionType.sectionPost}" data-title="Post Section" data-attribute="section-title">
          ${postSection}
          </section>`,
          image: postSectionImg,
        },
        {
          id: sectionType.sectionCardReview,
          title: 'Card Review Section',
          type: sectionType.sectionCardReview,
          tplType: TplType.gemPage,
          html: `<section data-section="${sectionType.sectionCardReview}-dwd2s" data-type="${sectionType.sectionCardReview}" data-title="Card Review Section" data-attribute="section-title">
                ${cardReviewSection}
            </section>`,
          image: cardReviewSectionImg,
        },
        {
          id: sectionType.sectionCardStep,
          title: 'Card Step Section',
          type: sectionType.sectionCardStep,
          tplType: TplType.gemPage,
          html: `<section data-section="${sectionType.sectionCardStep}-dwd2s" data-type="${sectionType.sectionCardStep}" data-title="Card Step Section" data-attribute="section-title">
                ${cardStepSection}
            </section>`,
          image: cardStepSectionImg,
        },
        {
          id: sectionType.sectionSocialMedia,
          title: 'Social Media Section',
          type: sectionType.sectionSocialMedia,
          tplType: TplType.gemPage,
          html: `<section data-section="${sectionType.sectionSocialMedia}-dwd2s" data-type="${sectionType.sectionSocialMedia}" data-title="Social Media Section" data-attribute="section-title">
                ${socialMediaSection}
            </section>`,
          image: socialMediaImg,
        },
        {
          id: sectionType.sectionFeaturedOffer,
          title: 'Featured Offer Section',
          type: sectionType.sectionFeaturedOffer,
          tplType: TplType.gemPage,
          html: `<section data-section="${sectionType.sectionFeaturedOffer}-dwd2s" data-type="${sectionType.sectionFeaturedOffer}" data-title="Featured Offer Section" data-attribute="section-title">
                ${featuredOfferSection}
            </section>`,
          image: featuredOfferImg,
        },
        {
          id: sectionType.sectionTextWithButton,
          title: 'Text with Button',
          type: sectionType.sectionTextWithButton,
          tplType: TplType.cardCTA,
          html: `<section data-section="${sectionType.sectionTextWithButton}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionTextWithButton}" data-title="Text with Button" data-attribute="section-title">
                ${textWithButtonSection}
            </section>`,
          image: textWithButtonSectionImg,
        },
        {
          id: sectionType.sectionFastvaluedealCountdown,
          title: 'Fastvaluedeal Countdown Section',
          type: sectionType.sectionFastvaluedealCountdown,
          tplType: TplType.cardCTA,
          html: `<section data-section="${sectionType.sectionFastvaluedealCountdown}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionFastvaluedealCountdown}" data-title="Fastvaluedeal Countdown Section" data-attribute="section-title">
                ${fastvaluedealCountdownSection}
            </section>`,
          image: fastvaluedealCountdownSectionImg,
        },
        {
          id: sectionType.sectionFastvaluedealCta,
          title: 'Fastvaluedeal CTA',
          type: sectionType.sectionFastvaluedealCta,
          tplType: TplType.cardCTA,
          html: `<section data-section="${sectionType.sectionFastvaluedealCta}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionFastvaluedealCta}" data-title="Fastvaluedeal CTA" data-attribute="section-title">
                ${fastvaluedealCtaSection}
            </section>`,
          image: fastvaluedealCtaSectionImg,
        },
        {
          id: sectionType.sectionFaqVital,
          title: 'FAQ Vital Section',
          type: sectionType.sectionFaqVital,
          tplType: TplType.FaqAccordion,
          html: `<section data-section="${sectionType.sectionFaqVital}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionFaqVital}" data-title="FAQ Vital Section" data-attribute="section-title">
                ${faqVitalSection}
            </section>`,
          image: faqVitalSectionImg,
        },
        {
          id: sectionType.sectionFastvaluedealFaq,
          title: 'Fastvaluedeal FAQ Section',
          type: sectionType.sectionFastvaluedealFaq,
          tplType: TplType.FaqAccordion,
          html: `<section data-section="${sectionType.sectionFastvaluedealFaq}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionFastvaluedealFaq}" data-title="Fastvaluedeal FAQ Section" data-attribute="section-title">
                ${fastvaluedealFaqSection}
            </section>`,
          image: fastvaluedealFaqSectionImg,
        },
        {
          id: sectionType.sectionFastvaluedealMoneyBackGuarantee,
          title: 'Fastvaluedeal Money Back Guarantee',
          type: sectionType.sectionFastvaluedealMoneyBackGuarantee,
          tplType: TplType.cardCTA,
          html: `<section data-section="${sectionType.sectionFastvaluedealMoneyBackGuarantee}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionFastvaluedealMoneyBackGuarantee}" data-title="Fastvaluedeal Money Back Guarantee" data-attribute="section-title">
                ${fastvaluedealMoneyBackGuaranteeSection}
            </section>`,
          image: fastvaluedealMoneyBackGuaranteeSectionImg,
        },
        {
          id: sectionType.sectionFastvaluedealReviewer,
          title: 'Fastvaluedeal Reviewer',
          type: sectionType.sectionFastvaluedealReviewer,
          tplType: TplType.reviewGrid,
          html: `<section data-section="${sectionType.sectionFastvaluedealReviewer}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionFastvaluedealReviewer}" data-title="Fastvaluedeal Reviewer" data-attribute="section-title">
                ${fastvaluedealReviewerSection}
            </section>`,
          image: fastvaluedealReviewerSectionImg,
        },
        {
          id: sectionType.sectionCardVitalSlider,
          title: 'Card Vital Slider',
          type: sectionType.sectionCardVitalSlider,
          tplType: TplType.cardCarousel,
          html: `<section data-section="${sectionType.sectionCardVitalSlider}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardVitalSlider}" data-title="Card Vital Slider" data-attribute="section-title">
                ${cardVitalSliderSection}
            </section>`,
          image: cardVitalSliderSectionImg,
        },
        {
          id: sectionType.sectionCardVitalSlider02,
          title: 'Card Vital Slider 02',
          type: sectionType.sectionCardVitalSlider02,
          tplType: TplType.cardCarousel,
          html: `<section data-section="${sectionType.sectionCardVitalSlider02}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardVitalSlider02}" data-title="Card Vital Slider 02" data-attribute="section-title">
                ${cardVitalSlider02Section}
            </section>`,
          image: cardVitalSlider02SectionImg,
        },
        {
          id: sectionType.sectionCardVitalSurround,
          title: 'Card Vital Surround',
          type: sectionType.sectionCardVitalSurround,
          tplType: TplType.SurroundItems,
          html: `<section data-section="${sectionType.sectionCardVitalSurround}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardVitalSurround}" data-title="Card Vital Surround" data-attribute="section-title">
                ${cardVitalSurroundSection}
            </section>`,
          image: cardVitalSurroundSectionImg,
        },
        {
          id: sectionType.sectionCardVitalTab,
          title: 'Card Vital Tab',
          type: sectionType.sectionCardVitalTab,
          tplType: TplType.Tabs,
          html: `<section data-section="${sectionType.sectionCardVitalTab}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardVitalTab}" data-title="Card Vital Tab" data-attribute="section-title">
                ${cardVitalTabSection}
            </section>`,
          image: cardVitalTabSectionImg,
        },
        {
          id: sectionType.sectionTableBenefitsComparison,
          title: 'Table Benefits Comparison Section',
          type: sectionType.sectionTableBenefitsComparison,
          tplType: TplType.gemPage,
          html: `<section data-section="${sectionType.sectionTableBenefitsComparison}-dwd2s" data-type="${sectionType.sectionTableBenefitsComparison}" data-title="Table Benefits Comparison Section" data-attribute="section-title">
                ${tableBenefitsComparison}
            </section>`,
          image: tableBenefitsComparisonImg,
        },
        {
          id: sectionType.sectionSocialComment,
          title: 'Social comment',
          type: sectionType.sectionSocialComment,
          tplType: TplType.gemPage,
          html: `<section data-section="${sectionType.sectionSocialComment}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionSocialComment}" data-title="Social Comment Section" data-attribute="section-title">
                ${socialCommentSection}
            </section>`,
          image: socialCommentSectionImg,
        },
        {
          id: sectionType.sectionCardBasicB1,
          title: 'Card Basic B1 Section',
          type: sectionType.sectionCardBasicB1,
          tplType: TplType.Basic,
          html: `<section data-section="${sectionType.sectionCardBasicB1}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardBasicB1}" data-title="Card Basic B1 Section" data-attribute="section-title">
                ${cardBasicB1Section}
            </section>`,
          image: cardBasicB1SectionImg,
        },
        {
          id: sectionType.sectionCardBasic,
          title: 'Card Basic B1 Section',
          type: sectionType.sectionCardBasic,
          tplType: TplType.Basic,
          html: `<section data-section="${sectionType.sectionCardBasic}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardBasic}" data-title="Card Basic Section" data-attribute="section-title">
                ${cardBasicSection}
            </section>`,
          image: cardBasicSectionImg,
        },
        {
          id: sectionType.sectionCardCompareB1,
          title: 'Card Compare B1 Section',
          type: sectionType.sectionCardCompareB1,
          tplType: TplType.CardCompareTwoImage,
          html: `<section data-section="${sectionType.sectionCardCompareB1}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardCompareB1}" data-title="Card Compare B1 Section" data-attribute="section-title">
                ${cardCompareB1Section}
            </section>`,
          image: cardCompareB1SectionImg,
        },
        {
          id: sectionType.sectionBannerBasicB1,
          title: 'Banner Basic B1 Section',
          type: sectionType.sectionBannerBasicB1,
          tplType: TplType.bannerMedia,
          html: `<section data-section="${sectionType.sectionBannerBasicB1}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionBannerBasicB1}" data-title="Banner Basic B1 Section" data-attribute="section-title">
                ${bannerBasicB1Section}
            </section>`,
          image: bannerBasicB1SectionImg,
        },
        {
          id: sectionType.sectionBannerBasic,
          title: 'Banner Basic Section',
          type: sectionType.sectionBannerBasic,
          tplType: TplType.bannerMedia,
          html: `<section data-section="${sectionType.sectionBannerBasic}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionBannerBasic}" data-title="Banner Basic Section" data-attribute="section-title">
                ${bannerBasicSection}
            </section>`,
          image: bannerBasicSectionImg,
        },
        {
          id: sectionType.sectionBannerFastvaluedeal,
          title: 'Banner FastValueDeal Section',
          type: sectionType.sectionBannerFastvaluedeal,
          tplType: TplType.bannerMedia,
          html: `<section data-section="${sectionType.sectionBannerFastvaluedeal}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionBannerFastvaluedeal}" data-title="Banner FastValueDeal Section" data-attribute="section-title">
                ${bannerFastvaluedealSection}
            </section>`,
          image: bannerFastvaluedealSectionImg,
        },
        {
          id: sectionType.sectionCardBannerRivoneed,
          title: 'Card Banner Rivoneed Section',
          type: sectionType.sectionCardBannerRivoneed,
          tplType: TplType.bannerMedia,
          html: `<section data-section="${sectionType.sectionCardBannerRivoneed}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardBannerRivoneed}" data-title="Card Banner Rivoneed Section" data-attribute="section-title">
                ${cardBannerRivoneedSection}
            </section>`,
          image: cardBannerRivoneedSectionImg,
        },
        {
          id: sectionType.sectionCardBanner02Rivoneed,
          title: 'Card Banner 02 Rivoneed Section',
          type: sectionType.sectionCardBanner02Rivoneed,
          tplType: TplType.bannerMedia,
          html: `<section data-section="${sectionType.sectionCardBanner02Rivoneed}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardBanner02Rivoneed}" data-title="Card Banner 02 Rivoneed Section" data-attribute="section-title">
                ${cardBanner02RivoneedSection}
            </section>`,
          image: cardBanner02RivoneedSectionImg,
        },
        {
          id: sectionType.sectionCardSatelliteRivoneed,
          title: 'Card Satellite Rivoneed Section',
          type: sectionType.sectionCardSatelliteRivoneed,
          tplType: TplType.Basic,
          html: `<section data-section="${sectionType.sectionCardSatelliteRivoneed}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardSatelliteRivoneed}" data-title="Card Satellite Rivoneed Section" data-attribute="section-title">
                ${cardSatelliteRivoneedSection}
            </section>`,
          image: cardSatelliteRivoneedSectionImg,
        },
        {
          id: sectionType.sectionCardWithSliderRivoneed,
          title: 'Card With Slider Rivoneed Section',
          type: sectionType.sectionCardWithSliderRivoneed,
          tplType: TplType.cardCarousel,
          html: `<section data-section="${sectionType.sectionCardWithSliderRivoneed}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardWithSliderRivoneed}" data-title="Card With Slider Rivoneed Section" data-attribute="section-title">
                ${cardWithSliderRivoneedSection}
            </section>`,
          image: cardWithSliderRivoneedSectionImg,
        },
        {
          id: sectionType.sectionCardGridItemRivoneed,
          title: 'Card Grid Item Rivoneed Section',
          type: sectionType.sectionCardGridItemRivoneed,
          tplType: TplType.Basic,
          html: `<section data-section="${sectionType.sectionCardGridItemRivoneed}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardGridItemRivoneed}" data-title="Card Grid Item Rivoneed Section" data-attribute="section-title">
                ${cardGridItemRivoneedSection}
            </section>`,
          image: cardGridItemRivoneedSectionImg,
        },
        {
          id: sectionType.sectionCardSliderRivoneed,
          title: 'Card Slider Rivoneed Section',
          type: sectionType.sectionCardSliderRivoneed,
          tplType: TplType.cardCarousel,
          html: `<section data-section="${sectionType.sectionCardSliderRivoneed}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardSliderRivoneed}" data-title="Card Slider Rivoneed Section" data-attribute="section-title">
                ${cardSliderRivoneedSection}
            </section>`,
          image: cardSliderRivoneedSectionImg,
        },
        {
          id: sectionType.sectionMarqueeRivoneed,
          title: 'Marquee Rivoneed Section',
          type: sectionType.sectionMarqueeRivoneed,
          tplType: TplType.markQueue,
          html: `<section data-section="${sectionType.sectionMarqueeRivoneed}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionMarqueeRivoneed}" data-title="Marquee Rivoneed Section" data-attribute="section-title">
                ${marqueeRivoneedSection}
            </section>`,
          image: marqueeRivoneedSectionImg,
        },
        {
          id: sectionType.sectionCardBasicRivoneed,
          title: 'Card Basic Rivoneed Section',
          type: sectionType.sectionCardBasicRivoneed,
          tplType: TplType.Basic,
          html: `<section data-section="${sectionType.sectionCardBasicRivoneed}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardBasicRivoneed}" data-title="Card Basic Rivoneed Section" data-attribute="section-title">
                ${cardBasicRivoneedSection}
            </section>`,
          image: cardBasicRivoneedSectionImg,
        },
        {
          id: sectionType.sectionCardBadgeRivoneed,
          title: 'Card Badge Rivoneed Section',
          type: sectionType.sectionCardBadgeRivoneed,
          tplType: TplType.Basic,
          html: `<section data-section="${sectionType.sectionCardBadgeRivoneed}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardBadgeRivoneed}" data-title="Card Badge Rivoneed Section" data-attribute="section-title">
                ${cardBadgeRivoneedSection}
            </section>`,
          image: cardBadgeRivoneedSectionImg,
        },
        {
          id: sectionType.sectionCardFaqRivoneed,
          title: 'Card FAQ Rivoneed Section',
          type: sectionType.sectionCardFaqRivoneed,
          tplType: TplType.FaqAccordion,
          html: `<section data-section="${sectionType.sectionCardFaqRivoneed}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardFaqRivoneed}" data-title="Card FAQ Rivoneed Section" data-attribute="section-title">
                ${cardFaqRivoneedSection}
            </section>`,
          image: cardFaqRivoneedSectionImg,
        },
        {
          id: sectionType.sectionCardBannerGatorz,
          title: 'Card Banner Gatorz Section',
          type: sectionType.sectionCardBannerGatorz,
          tplType: TplType.bannerMedia,
          html: `<section data-section="${sectionType.sectionCardBannerGatorz}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardBannerGatorz}" data-title="Card Banner Gatorz Section" data-attribute="section-title">
                ${cardBannerGatorzSection}
            </section>`,
          image: cardBannerGatorzSectionImg,
        },
        {
          id: sectionType.sectionCardGatorzCustom,
          title: 'Card Gatorz Custom Section',
          type: sectionType.sectionCardGatorzCustom,
          tplType: TplType.Basic,
          html: `<section data-section="${sectionType.sectionCardGatorzCustom}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardGatorzCustom}" data-title="Card Gatorz Custom Section" data-attribute="section-title">
                ${cardGatorzCustomSection}
            </section>`,
          image: cardGatorzCustomSectionImg,
        },
        {
          id: sectionType.sectionCardGatorzGridItem,
          title: 'Card Gatorz Grid Item Section',
          type: sectionType.sectionCardGatorzGridItem,
          tplType: TplType.Basic,
          html: `<section data-section="${sectionType.sectionCardGatorzGridItem}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardGatorzGridItem}" data-title="Card Gatorz Grid Item Section" data-attribute="section-title">
                ${cardGatorzGridItemSection}
            </section>`,
          image: cardGatorzGridItemSectionImg,
        },
        {
          id: sectionType.sectionCardFastvaluedealTitleImg,
          title: 'Card FastValueDeal Title Img Section',
          type: sectionType.sectionCardFastvaluedealTitleImg,
          tplType: TplType.Basic,
          html: `<section data-section="${sectionType.sectionCardFastvaluedealTitleImg}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardFastvaluedealTitleImg}" data-title="Card FastValueDeal Title Img Section" data-attribute="section-title">
                ${cardFastvaluedealTitleImgSection}
            </section>`,
          image: cardFastvaluedealTitleImgSectionImg,
        },
        {
          id: sectionType.sectionFastvaluedealCardBasic,
          title: 'Fastvaluedeal Card Basic',
          type: sectionType.sectionFastvaluedealCardBasic,
          tplType: TplType.Basic,
          html: `<section data-section="${sectionType.sectionFastvaluedealCardBasic}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionFastvaluedealCardBasic}" data-title="Fastvaluedeal Card Basic" data-attribute="section-title">
                ${fastvaluedealCardBasicSection}
            </section>`,
          image: fastvaluedealCardBasicSectionImg,
        },
        {
          id: sectionType.sectionFastvaluedealCardStep,
          title: 'Fastvaluedeal Card Step',
          type: sectionType.sectionFastvaluedealCardStep,
          tplType: TplType.CardStepInstructions,
          html: `<section data-section="${sectionType.sectionFastvaluedealCardStep}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionFastvaluedealCardStep}" data-title="Fastvaluedeal Card Step" data-attribute="section-title">
                ${fastvaluedealCardStepSection}
            </section>`,
          image: fastvaluedealCardStepSectionImg,
        },
        {
          id: sectionType.sectionFastvaluedealCompareBenefits,
          title: 'Fastvaluedeal Compare Benefits',
          type: sectionType.sectionFastvaluedealCompareBenefits,
          tplType: TplType.CardCompareTwoImage,
          html: `<section data-section="${sectionType.sectionFastvaluedealCompareBenefits}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionFastvaluedealCompareBenefits}" data-title="Fastvaluedeal Compare Benefits" data-attribute="section-title">
                ${fastvaluedealCompareBenefitsSection}
            </section>`,
          image: fastvaluedealCompareBenefitsSectionImg,
        },
        {
          id: sectionType.sectionFastvaluedealTable,
          title: 'Fastvaluedeal Table',
          type: sectionType.sectionFastvaluedealTable,
          tplType: TplType.table,
          html: `<section data-section="${sectionType.sectionFastvaluedealTable}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionFastvaluedealTable}" data-title="Fastvaluedeal Table" data-attribute="section-title">
                ${fastvaluedealTableSection}
            </section>`,
          image: fastvaluedealTableSectionImg,
        },
        {
          id: sectionType.sectionSliderFastvaluedeal01,
          title: 'Slider FastValueDeal 01 Section',
          type: sectionType.sectionSliderFastvaluedeal01,
          tplType: TplType.cardCarousel,
          html: `<section data-section="${sectionType.sectionSliderFastvaluedeal01}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionSliderFastvaluedeal01}" data-title="Slider FastValueDeal 01 Section" data-attribute="section-title">
                ${sliderFastvaluedeal01Section}
            </section>`,
          image: sliderFastvaluedeal01SectionImg,
        },
        {
          id: sectionType.sectionTableSmallB1,
          title: 'Table Small B1 Section',
          type: sectionType.sectionTableSmallB1,
          tplType: TplType.table,
          html: `<section data-section="${sectionType.sectionTableSmallB1}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionTableSmallB1}" data-title="Table Small B1 Section" data-attribute="section-title">
                ${tableSmallB1Section}
            </section>`,
          image: tableSmallB1SectionImg,
        },
        {
          id: sectionType.sectionIconWithTextB1,
          title: 'Icon With Text B1 Section',
          type: sectionType.sectionIconWithTextB1,
          tplType: TplType.IconsWithText,
          html: `<section data-section="${sectionType.sectionIconWithTextB1}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionIconWithTextB1}" data-title="Icon With Text B1 Section" data-attribute="section-title">
                ${iconWithTextB1Section}
            </section>`,
          image: iconWithTextB1SectionImg,
        },
        {
          id: sectionType.sectionCardMultiTool,
          title: 'Card Multi Tool Section',
          type: sectionType.sectionCardMultiTool,
          tplType: TplType.CardMultiTool,
          html: `<section data-section="${sectionType.sectionCardMultiTool}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardMultiTool}" data-title="Card Multi Tool Section" data-attribute="section-title">
                ${cardMultiToolSection}
            </section>`,
          image: cardMultiToolImg,
        },
        {
          id: sectionType.sectionCardMultiToolYuri,
          title: 'Card Multi Tool Yuri Section',
          type: sectionType.sectionCardMultiToolYuri,
          tplType: TplType.CardMultiTool,
          html: `<section data-section="${sectionType.sectionCardMultiToolYuri}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardMultiToolYuri}" data-title="Card Multi Tool Yuri Section" data-attribute="section-title">
                ${cardMultiToolYuriSection}
            </section>`,
          image: cardMultiToolYuriSectionImg,
        },
        {
          id: sectionType.sectionCardMultiToolDouble,
          title: 'Double Card Multi Tool Section',
          type: sectionType.sectionCardMultiToolDouble,
          tplType: TplType.CardMultiToolDouble,
          html: `<section data-section="${sectionType.sectionCardMultiToolDouble}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardMultiToolDouble}" data-title="Card Multi Tool Double Section" data-attribute="section-title">
                ${cardMultiToolDoubleSection}
            </section>`,
          image: cardMultiToolDoubleImg,
        },
        {
          id: sectionType.sectionCardCompareProduct,
          title: 'Card Compare Product Section',
          type: sectionType.sectionCardCompareProduct,
          tplType: TplType.CardCompareTwoImage,
          html: `<section data-section="${sectionType.sectionCardCompareProduct}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionCardCompareProduct}" data-title="Card Compare Product Section" data-attribute="section-title">
                ${cardCompareProductSection}
            </section>`,
          image: cardCompareProductSectionImg,
        },
        {
          id: sectionType.sectionMarkqueueRows,
          title: 'Markqueue Rows Section',
          type: sectionType.sectionMarkqueueRows,
          tplType: TplType.markQueue,
          html: `<section data-section="${sectionType.sectionMarkqueueRows}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionMarkqueueRows}" data-title="Markqueue Rows Section" data-attribute="section-title">
                ${markqueueRowsSection}
            </section>`,
          image: markqueueRowsImg,
        },
        {
          id: sectionType.sectionFbPost03,
          title: 'FB Post 03 Section',
          type: sectionType.sectionFbPost03,
          tplType: TplType.gemPage,
          html: `<section data-section="${sectionType.sectionFbPost03}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionFbPost03}" data-title="FB Post 03 Section" data-attribute="section-title">
                ${fbPost03Section}
            </section>`,
          image: fbPost03Img,
        },
        {
          id: sectionType.sectionReviewVital,
          title: 'Review Vital Section',
          type: sectionType.sectionReviewVital,
          tplType: TplType.reviewGrid,
          html: `<section data-section="${sectionType.sectionReviewVital}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionReviewVital}" data-title="Review Vital Section" data-attribute="section-title">
                ${reviewVitalSection}
            </section>`,
          image: reviewVitalSectionImg,
        },
        {
          id: sectionType.sectionTryherReviewGrid,
          title: 'Tryher review grid',
          tplType: TplType.reviewGrid,
          type: sectionType.sectionTryherReviewGrid,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionTryherReviewGrid}-tryher" data-type="${sectionType.sectionTryherReviewGrid}" data-title="Tryher review grid" data-attribute="section-title">
                ${tryherReviewGrid}
            </section>`,
          image: tryherReviewGridImg,
        },
        {
          id: sectionType.sectionTryherGridPercent,
          title: 'Tryher grid percent',
          tplType: TplType.reviewGrid,
          type: sectionType.sectionTryherGridPercent,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionTryherGridPercent}-tryher" data-type="${sectionType.sectionTryherGridPercent}" data-title="Tryher grid percent" data-attribute="section-title">
                ${tryherGridPercent}
            </section>`,
          image: tryherGridPercentImg,
        },
        {
          id: sectionType.sectionTryherTimeline,
          title: 'Tryher timeline',
          tplType: TplType.CardTimeline,
          type: sectionType.sectionTryherTimeline,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionTryherTimeline}-tryher" data-type="${sectionType.sectionTryherTimeline}" data-title="Tryher timeline" data-attribute="section-title">
                ${tryherTimeline}
            </section>`,
          image: tryherTimelineImg,
        },
        {
          id: sectionType.sectionTryherCardCompare,
          title: 'Tryher card compare',
          tplType: TplType.CardCompareTwoImage,
          type: sectionType.sectionTryherCardCompare,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionTryherCardCompare}-tryher" data-type="${sectionType.sectionTryherCardCompare}" data-title="Tryher card compare" data-attribute="section-title">
                ${tryherCardCompare}
            </section>`,
          image: tryherCardCompareImg,
        },
        {
          id: sectionType.sectionTryherCardBasic,
          title: 'Tryher card basic',
          tplType: TplType.Basic,
          type: sectionType.sectionTryherCardBasic,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionTryherCardBasic}-tryher" data-type="${sectionType.sectionTryherCardBasic}" data-title="Tryher card basic" data-attribute="section-title">
                ${tryherCardBasic}
            </section>`,
          image: tryherCardBasicImg,
        },
        //hurrybox-------------------------------------------------------------------------------------------------#>
        {
          id: sectionType.sectionFreestyleHurryBox,
          title: 'Freestyle Section',
          type: sectionType.sectionFreestyleHurryBox,
          tplType: TplType.FreeLayoutHurryBox,
          html: `<section class="ck-content" data-section="${sectionType.sectionFreestyleHurryBox}-uluark" data-type="${sectionType.sectionFreestyleHurryBox}" data-title="Hurybox Freestyle">
               ${freestyleHurrybox}
            </section>`,
          image: freestyleImg,
        },
        {
          id: sectionType.sectionMarkqueueOrthopedic,
          title: 'Markqueue Orthopedic Section',
          tplType: TplType.textCarousel,
          type: sectionType.sectionMarkqueueOrthopedic,
          html: `<section data-section="${sectionType.sectionMarkqueueOrthopedic}-dwd2" data-type="${sectionType.sectionMarkqueueOrthopedic}" data-title="Markqueue Orthopedic Section" data-attribute="section-title">
                ${markqueueOrthopedicSection}
            </section>`,
          image: markqueueOrthopedicImg,
        },
        {
          id: sectionType.sectionOrthopedicFeaturesGrid,
          title: 'Orthopedic features grid',
          tplType: TplType.ProductGrid,
          type: sectionType.sectionOrthopedicFeaturesGrid,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionOrthopedicFeaturesGrid}-o76cxz" data-type="${sectionType.sectionOrthopedicFeaturesGrid}" data-title="Orthopedic features grid" data-attribute="section-title">
              ${orthopedicFeaturesGridSection}
          </section>`,
          image: orthopedicFeaturesGridImg,
        },
        {
          id: sectionType.sectionOrthopedicCardFeatures,
          title: 'Orthopedic card features',
          tplType: TplType.Basic,
          type: sectionType.sectionOrthopedicCardFeatures,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionOrthopedicCardFeatures}-o77cxz" data-type="${sectionType.sectionOrthopedicCardFeatures}" data-title="Orthopedic card features" data-attribute="section-title">
              ${orthopedicCardFeaturesSection}
          </section>`,
          image: orthopedicCardFeaturesImg,
        },
        {
          id: sectionType.sectionOrthopedicCardReview,
          title: 'Orthopedic card review',
          tplType: TplType.cardCTA,
          type: sectionType.sectionOrthopedicCardReview,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionOrthopedicCardReview}-o77cxz" data-type="${sectionType.sectionOrthopedicCardReview}" data-title="Orthopedic card review" data-attribute="section-title">
              ${orthopedicCardReviewSection}
          </section>`,
          image: orthopedicCardReviewImg,
        },
        {
          id: sectionType.sectionOrthopedicCardBasic,
          title: 'Orthopedic card basic',
          tplType: TplType.Basic,
          type: sectionType.sectionOrthopedicCardBasic,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionOrthopedicCardBasic}-o78cxz" data-type="${sectionType.sectionOrthopedicCardBasic}" data-title="Orthopedic card basic" data-attribute="section-title">
              ${orthopedicCardBasicSection}
          </section>`,
          image: orthopedicCardBasicImg,
        },
        {
          id: sectionType.sectionLosaprilyImagesGrid,
          title: 'Losaprily images grid',
          tplType: TplType.ProductGrid,
          type: sectionType.sectionLosaprilyImagesGrid,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionLosaprilyImagesGrid}-lp9img" data-type="${sectionType.sectionLosaprilyImagesGrid}" data-title="Losaprily images grid" data-attribute="section-title">
              ${losaprilyImagesGridSection}
          </section>`,
          image: losaprilyImagesGridSectionImg,
        },
        {
          id: sectionType.sectionLosaprilyCardBanner,
          title: 'Losaprily Card Banner Section',
          type: sectionType.sectionLosaprilyCardBanner,
          tplType: TplType.bannerMedia,
          html: `<section data-section="${sectionType.sectionLosaprilyCardBanner}-losaban" data-enable-anchor="false" data-type="${sectionType.sectionLosaprilyCardBanner}" data-title="Losaprily Card Banner Section" data-attribute="section-title">
                ${losaprilyCardBannerSection}
            </section>`,
          image: losaprilyCardBannerImg,
        },

        {
          id: sectionType.sectionSowhatbuyCardBasic,
          title: 'Sowhatbuy card basic',
          tplType: TplType.Basic,
          type: sectionType.sectionSowhatbuyCardBasic,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionSowhatbuyCardBasic}-swcb01" data-type="${sectionType.sectionSowhatbuyCardBasic}" data-title="Sowhatbuy card basic" data-attribute="section-title">
              ${sowhatbuyCardBasicSection}
          </section>`,
          image: sowhatbuyCardBasicSectionImg,
        },
        {
          id: sectionType.sectionSowhatbuyGuaranteeMarquee,
          title: 'Sowhatbuy guarantee marquee',
          tplType: TplType.textCarousel,
          type: sectionType.sectionSowhatbuyGuaranteeMarquee,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionSowhatbuyGuaranteeMarquee}-swgm01" data-type="${sectionType.sectionSowhatbuyGuaranteeMarquee}" data-title="Sowhatbuy guarantee marquee" data-attribute="section-title">
              ${sowhatbuyGuaranteeMarqueeSection}
          </section>`,
          image: sowhatbuyGuaranteeMarqueeSectionImg,
        },
        {
          id: sectionType.sectionSowhatbuyFeaturesSlider,
          title: 'Sowhatbuy features slider',
          tplType: TplType.reviewGrid,
          type: sectionType.sectionSowhatbuyFeaturesSlider,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionSowhatbuyFeaturesSlider}-swfs01" data-type="${sectionType.sectionSowhatbuyFeaturesSlider}" data-title="Sowhatbuy features slider" data-attribute="section-title">
              ${sowhatbuyFeaturesSliderSection}
          </section>`,
          image: sowhatbuyFeaturesSliderSectionImg,
        },
        {
          id: sectionType.sectionSowhatbuyReward,
          title: 'Sowhatbuy reward',
          tplType: TplType.Basic,
          type: sectionType.sectionSowhatbuyReward,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionSowhatbuyReward}-swrw01" data-type="${sectionType.sectionSowhatbuyReward}" data-title="Sowhatbuy reward" data-attribute="section-title">
              ${sowhatbuyRewardSection}
          </section>`,
          image: sowhatbuyRewardSectionImg,
        },
        {
          id: sectionType.sectionImageWithTextCol1,
          title: 'Image With Text Col 1 Section',
          tplType: TplType.Basic,
          type: sectionType.sectionImageWithTextCol1,
          html: `<section data-section="${sectionType.sectionImageWithTextCol1}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionImageWithTextCol1}" data-title="Image With Text Col 1 Section" data-attribute="section-title">
              ${imageWithTextCol1Section}
          </section>`,
          image: imageWithTextCol1SectionImg,
        },
        {
          id: sectionType.sectionSideBySideGridIcon,
          title: 'Side By Side Grid Icon Section',
          tplType: TplType.Basic,
          type: sectionType.sectionSideBySideGridIcon,
          html: `<section data-section="${sectionType.sectionSideBySideGridIcon}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionSideBySideGridIcon}" data-title="Side By Side Grid Icon Section" data-attribute="section-title">
              ${sideBySideGridIconSection}
          </section>`,
          image: sideBySideGridIconSectionImg,
        },
        {
          id: sectionType.sectionSowhatbuyCardImage,
          title: 'Sowhatbuy card image',
          tplType: TplType.bannerMedia,
          type: sectionType.sectionSowhatbuyCardImage,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionSowhatbuyCardImage}-swci01" data-type="${sectionType.sectionSowhatbuyCardImage}" data-title="Sowhatbuy card image" data-attribute="section-title">
              ${sowhatbuyCardImageSection}
          </section>`,
          image: sowhatbuyCardImageSectionImg,
        },
        //hurrybox countdown
        {
          id: sectionType.sectionCoutdownHurryBox,
          title: 'Countdown Section',
          type: sectionType.sectionCoutdownHurryBox,
          tplType: TplType.FreeLayoutHurryBox,
          html: `<section class="ck-content" data-section="${sectionType.sectionCoutdownHurryBox}-uluark"
                data-type="${sectionType.sectionCoutdownHurryBox}" data-title="Hurybox Countdown">
               ${countdownSection}
            </section>`,
          image: countdownImg,
        },

        {
          id: sectionType.sectionSizingChartHurryBox,
          title: 'Sizing Chart Section',
          type: sectionType.sectionSizingChartHurryBox,
          tplType: TplType.FreeLayoutHurryBox,
          html: `<section class="ck-content" data-section="${sectionType.sectionSizingChartHurryBox}-uluark"
                data-type="${sectionType.sectionSizingChartHurryBox}" data-title="Sizing Chart">
               ${sizingChartSection}
            </section>`,
          image: sizingChartImg,
        },
        {
          id: sectionType.sectionHarryboxYuri,
          title: 'Yuri Section',
          type: sectionType.sectionHarryboxYuri,
          tplType: TplType.FreeLayoutHurryBox,
          html: `<section class="ck-content" data-section="${sectionType.sectionHarryboxYuri}-uluark"
                data-type="${sectionType.sectionHarryboxYuri}" data-title="Yuri Section">
               ${hurryboxYuriSection}
            </section>`,
          image: hurryboxYuriSectionImg,
        },
        {
          id: sectionType.sectionTabs,
          title: 'Tabs Section',
          type: sectionType.sectionTabs,
          tplType: TplType.Tabs,
          html: `<section data-section="${sectionType.sectionTabs}-sdsj2" data-type="${sectionType.sectionTabs}" data-title="Tabs Section" data-attribute="section-title">
              ${tabsSection}
            </section>`,
          image: tabsSectionImg,
        },
        {
          id: sectionType.sectionSaintbrandFeaturesGrid,
          title: 'Saintbrand features grid',
          tplType: TplType.FreeLayoutHurryBox,
          type: sectionType.sectionSaintbrandFeaturesGrid,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionSaintbrandFeaturesGrid}-sf8g2m" data-type="${sectionType.sectionSaintbrandFeaturesGrid}" data-title="Saintbrand features grid" data-attribute="section-title">
              ${saintbrandFeaturesGridSection}
          </section>`,
          image: saintbrandFeaturesGridSectionImg,
        },
        {
          id: sectionType.sectionMadamSizeCalculator,
          title: 'Madam size calculator',
          tplType: TplType.FreeLayoutHurryBox,
          type: sectionType.sectionMadamSizeCalculator,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionMadamSizeCalculator}-md5zc1" data-type="${sectionType.sectionMadamSizeCalculator}" data-title="Madam size calculator" data-attribute="section-title">
              ${madamSizeCalculatorSection}
          </section>`,
          image: madamsizeCalculatorImg,
        },

        // order policy----------------------------------------------------------------------------------------------#>
        {
          id: sectionType.sectionGuaranteedSafeCheckout,
          title: 'Guaranteed Safe Checkout Section',
          type: sectionType.sectionGuaranteedSafeCheckout,
          tplType: TplType.guaranteedSafeCheckout,
          html: `<section class="ck-content" data-section="${sectionType.sectionGuaranteedSafeCheckout}-uluark"
                data-type="${sectionType.sectionGuaranteedSafeCheckout}" data-title="Guaranteed Safe Checkout">
               ${guaranteedSafeCheckoutSection}
            </section>`,
          image: guaranteedSafeCheckoutImg,
        },
        {
          id: sectionType.sectionGuaranteedSafeCheckout,
          title: 'Guaranteed Safe Checkout Section 02',
          type: sectionType.sectionGuaranteedSafeCheckout02,
          tplType: TplType.guaranteedSafeCheckout,
          html: `<section class="ck-content" data-section="${sectionType.sectionGuaranteedSafeCheckout02}-uluark"
                data-type="${sectionType.sectionGuaranteedSafeCheckout02}" data-title="Guaranteed Safe Checkout 02">
               ${guaranteedSafeCheckoutSection02}
            </section>`,
          image: guaranteedSafeCheckoutImg02,
        },
        {
          id: sectionType.sectionOrderInfo,
          title: 'Order Info Section',
          type: sectionType.sectionOrderInfo,
          tplType: TplType.orderInfo,
          html: `<section class="ck-content" data-section="${sectionType.sectionOrderInfo}-uluark"
                data-type="${sectionType.sectionOrderInfo}" data-title="Order Info Section">
               ${orderInfoSection}
            </section>`,
          image: orderInfoImg,
        },
        {
          id: sectionType.sectionPolicyAccordionBasic,
          title: 'Policy Accordion Basic Section',
          type: sectionType.sectionPolicyAccordionBasic,
          tplType: TplType.orderInfo,
          html: `<section class="ck-content" data-section="${sectionType.sectionPolicyAccordionBasic}-uluark"
                data-type="${sectionType.sectionPolicyAccordionBasic}" data-title="Policy Accordion Basic Section">
               ${policyAccordionBasicSection}
            </section>`,
          image: policyAccordionBasicImg,
        },
        {
          id: sectionType.sectionPolicyYuriAccordion,
          title: 'Policy Yuri Accordion Section',
          type: sectionType.sectionPolicyYuriAccordion,
          tplType: TplType.orderInfo,
          html: `<section class="ck-content" data-section="${sectionType.sectionPolicyYuriAccordion}-uluark"
                data-type="${sectionType.sectionPolicyYuriAccordion}" data-title="Policy Yuri Accordion Section">
               ${policyYuriAccordionSection}
            </section>`,
          image: policyYuriAccordionSectionImg,
        },
        {
          id: sectionType.sectionPolicyYuriList,
          title: 'Policy Yuri List Section',
          type: sectionType.sectionPolicyYuriList,
          tplType: TplType.orderInfo,
          html: `<section class="ck-content" data-section="${sectionType.sectionPolicyYuriList}-uluark"
                data-type="${sectionType.sectionPolicyYuriList}" data-title="Policy Yuri List Section">
               ${policyYuriListSection}
            </section>`,
          image: policyYuriListSectionImg,
        },
        {
          id: sectionType.sectionPolicyYuriVideos,
          title: 'Policy Yuri Videos Section',
          type: sectionType.sectionPolicyYuriVideos,
          tplType: TplType.orderInfo,
          html: `<section class="ck-content" data-section="${sectionType.sectionPolicyYuriVideos}-uluark"
                data-type="${sectionType.sectionPolicyYuriVideos}" data-title="Policy Yuri Videos Section">
               ${policyYuriVideosSection}
            </section>`,
          image: policyYuriVideosSectionImg,
        },
        {
          id: sectionType.sectionPolicyYuriReivew,
          title: 'Policy Yuri Review Section',
          type: sectionType.sectionPolicyYuriReivew,
          tplType: TplType.orderInfo,
          html: `<section class="ck-content" data-section="${sectionType.sectionPolicyYuriReivew}-uluark"
                data-type="${sectionType.sectionPolicyYuriReivew}" data-title="Policy Yuri Review Section">
               ${policyYuriReivewSection}
            </section>`,
          image: policyYuriReivewSectionImg,
        },
        {
          id: sectionType.sectionFreestyleOrderPolicy,
          title: 'Freestyle Order Policy Section',
          type: sectionType.sectionFreestyleOrderPolicy,
          tplType: TplType.freestyleOrderPolicy,
          html: `<section class="ck-content" data-section="${sectionType.sectionFreestyleOrderPolicy}-uluark"
                data-type="${sectionType.sectionFreestyleOrderPolicy}" data-title="Freestyle Order Policy Section">
               ${freestyleOrderPolicySection}
            </section>`,
          image: freestyleOrderPolicyImg,
        },
        {
          id: sectionType.sectionTrustBadge,
          title: 'Trust Badge Section',
          type: sectionType.sectionTrustBadge,
          tplType: TplType.orderInfo,
          html: `<section class="ck-content" data-section="${sectionType.sectionTrustBadge}-uluark"
                data-type="${sectionType.sectionTrustBadge}" data-title="Trust Badge Section">
               ${trustBadgeSection}
            </section>`,
          image: trustBadgeImg,
        },
        {
          id: sectionType.sectionSaintbrandShipping,
          title: 'Saintbrand Shipping',
          type: sectionType.sectionSaintbrandShipping,
          tplType: TplType.orderInfo,
          html: `<section class="ck-content" data-section="${sectionType.sectionSaintbrandShipping}-uluark"
                data-type="${sectionType.sectionSaintbrandShipping}" data-title="Saintbrand Shipping">
               ${saintbrandShippingSection}
            </section>`,
          image: saintbrandShippingImg,
        },
        {
          id: sectionType.sectionCardCedrowBenefitsPolicy,
          title: 'Cedrow Benefits Policy Section',
          type: sectionType.sectionCardCedrowBenefitsPolicy,
          tplType: TplType.orderInfo,
          html: `<section class="ck-content" data-section="${sectionType.sectionCardCedrowBenefitsPolicy}-uluark"
                data-type="${sectionType.sectionCardCedrowBenefitsPolicy}" data-title="Cedrow Benefits Policy Section">
               ${cardCedrowBenefitsPolicySection}
            </section>`,
          image: cardCedrowBenefitsPolicyImg,
        },
        {
          id: sectionType.sectionCardCedrowGridIcons,
          title: 'Card Cedrow Grid Icons Section',
          type: sectionType.sectionCardCedrowGridIcons,
          tplType: TplType.IconsWithText,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardCedrowGridIcons}-dwd2s" data-type="${sectionType.sectionCardCedrowGridIcons}" data-title="Card Cedrow Grid Icons Section" data-attribute="section-title">
                ${cardCedrowGridIconsSection}
            </section>`,
          image: cardCedrowGridIconsImg,
        },
        {
          id: sectionType.sectionCardMediaWithSliderLosaprily,
          title: 'Card Media With Slider Losaprily Section',
          type: sectionType.sectionCardMediaWithSliderLosaprily,
          tplType: TplType.CardMedia,
          html: `<section data-section="${sectionType.sectionCardMediaWithSliderLosaprily}-losapri" data-enable-anchor="false" data-type="${sectionType.sectionCardMediaWithSliderLosaprily}" data-title="Card Media With Slider Losaprily Section" data-attribute="section-title">
                ${cardMediaWithSliderLosaprilySection}
            </section>`,
          image: losaprilyCardMediaWithSliderImg,
        },
        {
          id: sectionType.sectionCardTabWithContentLosaprily,
          title: 'Card Tab With Content Losaprily Section',
          type: sectionType.sectionCardTabWithContentLosaprily,
          tplType: TplType.Tabs,
          html: `<section data-section="${sectionType.sectionCardTabWithContentLosaprily}-losatab" data-enable-anchor="false" data-type="${sectionType.sectionCardTabWithContentLosaprily}" data-title="Card Tab With Content Losaprily Section" data-attribute="section-title">
                ${cardTabWithContentLosaprilySection}
            </section>`,
          image: losaprilyCardTabWithContentImg,
        },
        {
          id: sectionType.sectionCardBannerSowhatbuy,
          title: 'Card Banner Sowhatbuy Section',
          type: sectionType.sectionCardBannerSowhatbuy,
          tplType: TplType.bannerMedia,
          html: `<section data-section="${sectionType.sectionCardBannerSowhatbuy}-sowhat" data-enable-anchor="false" data-type="${sectionType.sectionCardBannerSowhatbuy}" data-title="Card Banner Sowhatbuy Section" data-attribute="section-title">
                ${cardBannerSowhatbuySection}
            </section>`,
          image: sowhatbuyCardBannerImg,
        },
        {
          id: sectionType.sectionCardItemsSowhatbuy,
          title: 'Card Items Sowhatbuy Section',
          type: sectionType.sectionCardItemsSowhatbuy,
          tplType: TplType.sectionItemsGrid,
          html: `<section data-section="${sectionType.sectionCardItemsSowhatbuy}-items" data-enable-anchor="false" data-type="${sectionType.sectionCardItemsSowhatbuy}" data-title="Card Items Sowhatbuy Section" data-attribute="section-title">
                ${cardItemsSowhatbuySection}
            </section>`,
          image: sowhatbuyCardItemsImg,
        },
        {
          id: sectionType.sectionCardCompareSowhatbuy,
          title: 'Card Compare Sowhatbuy Section',
          type: sectionType.sectionCardCompareSowhatbuy,
          tplType: TplType.bannerMedia,
          html: `<section data-section="${sectionType.sectionCardCompareSowhatbuy}-compare" data-enable-anchor="false" data-type="${sectionType.sectionCardCompareSowhatbuy}" data-title="Card Compare Sowhatbuy Section" data-attribute="section-title">
                ${cardCompareSowhatbuySection}
            </section>`,
          image: sowhatbuyCardCompareImg,
        },
        {
          id: sectionType.sectionLeonieandcoReviewGrid,
          title: 'Leonieandco review grid',
          type: sectionType.sectionLeonieandcoReviewGrid,
          tplType: TplType.orderInfo,
          html: `<section class="ck-content" data-enable-anchor="false"
                data-section="${sectionType.sectionLeonieandcoReviewGrid}-leonieandco"
                data-type="${sectionType.sectionLeonieandcoReviewGrid}"
                data-title="Leonieandco review grid" data-attribute="section-title">
               ${leonieandcoReviewGrid}
            </section>`,
          image: leonieandcoReviewGridImg,
        },
        {
          id: sectionType.sectionCedrowFreetypeContent,
          title: 'Cedrow Freetype Content',
          type: sectionType.sectionCedrowFreetypeContent,
          tplType: TplType.Basic,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCedrowFreetypeContent}-dwd2s" data-type="${sectionType.sectionCedrowFreetypeContent}" data-title="Cedrow Freetype Content" data-attribute="section-title">
                ${cedrowFreetypeContentSection}
            </section>`,
          image: cedrowFreetypeContentImg,
        },
        {
          id: sectionType.sectionCardCedrowWithTab,
          title: 'Card Tab Timeline Section',
          type: sectionType.sectionCardCedrowWithTab,
          tplType: TplType.Tabs,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardCedrowWithTab}-dwd2s" data-type="${sectionType.sectionCardCedrowWithTab}" data-title="Card Tab Timeline Section" data-attribute="section-title">
                ${cardCedrowWithTabSection}
            </section>`,
          image: cardCedrowWithTabImg,
        },
        {
          id: sectionType.sectionCardCedrowSideBySide,
          title: 'Card Side by Side Media',
          type: sectionType.sectionCardCedrowSideBySide,
          tplType: TplType.CardMedia,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardCedrowSideBySide}-dwd2s" data-type="${sectionType.sectionCardCedrowSideBySide}" data-title="Card Side by Side Media" data-attribute="section-title">
                ${cardCedrowSideBySideSection}
            </section>`,
          image: cardCedrowSideBySideImg,
        },
        {
          id: sectionType.sectionCardCedrowWithTabel,
          title: 'Card Cedrow with Table',
          type: sectionType.sectionCardCedrowWithTabel,
          tplType: TplType.table,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionCardCedrowWithTabel}-dwd2s" data-type="${sectionType.sectionCardCedrowWithTabel}" data-title="Card Cedrow with Table" data-attribute="section-title">
                ${cardCedrowWithTabelSection}
            </section>`,
          image: cardCedrowWithTabelImg,
        },
        {
          id: sectionType.sectionUpairyTabs,
          title: 'Upairy tabs',
          type: sectionType.sectionUpairyTabs,
          tplType: TplType.CardMedia,
          html: `<section class='ck-content' data-enable-anchor='false'
                data-section='${sectionType.sectionUpairyTabs}-upairy'
                data-type='${sectionType.sectionUpairyTabs}'
                data-title='Upairy tabs' data-attribute='section-title'>
               ${upairyTabs}
            </section>`,
          image: upairyTabsImg,
        },
        {
          id: sectionType.sectionUpairyTimeline,
          title: 'Upairy timeline',
          type: sectionType.sectionUpairyTimeline,
          tplType: TplType.CardTimeline,
          html: `<section class='ck-content' data-enable-anchor='false'
                data-section='${sectionType.sectionUpairyTimeline}-upairy'
                data-type='${sectionType.sectionUpairyTimeline}'
                data-title='Upairy timeline' data-attribute='section-title'>
               ${upairyTimeline}
            </section>`,
          image: upairyTimelineImg,
        },
        {
          id: sectionType.sectionUpairyCard,
          group: 'order-policy',
          title: 'Upairy card',
          type: sectionType.sectionUpairyCard,
          tplType: TplType.Basic,
          html: `<section class='ck-content' data-enable-anchor='false'
                data-section='${sectionType.sectionUpairyCard}-upairy'
                data-type='${sectionType.sectionUpairyCard}'
                data-title='Upairy card' data-attribute='section-title'>
               ${upairyCard}
            </section>`,
          image: upairyCardImg,
        },
        {
          id: sectionType.sectionUpairyCompareCard,
          title: 'Upairy compare card',
          type: sectionType.sectionUpairyCompareCard,
          tplType: TplType.CardCompareTwoImage,
          html: `<section class='ck-content' data-enable-anchor='false'
                data-section='${sectionType.sectionUpairyCompareCard}-upairy'
                data-type='${sectionType.sectionUpairyCompareCard}'
                data-title='Upairy compare card' data-attribute='section-title'>
               ${upairyCompareCard}
            </section>`,
          image: upairyCompareCardImg,
        },
        {
          id: sectionType.sectionKonfortifyFb,
          title: 'Konfortify FB Section',
          type: sectionType.sectionKonfortifyFb,
          tplType: TplType.gemPage,
          html: `<section data-section="${sectionType.sectionKonfortifyFb}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionKonfortifyFb}" data-title="Konfortify FB Section" data-attribute="section-title">
                ${konfortifyFbSection}
            </section>`,
          image: konfortifyFbImg,
        },
        {
          id: sectionType.sectionKonfortifyCardBasic,
          title: 'Konfortify card basic',
          tplType: TplType.Basic,
          type: sectionType.sectionKonfortifyCardBasic,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionKonfortifyCardBasic}-konfortify" data-type="${sectionType.sectionKonfortifyCardBasic}" data-title="Konfortify card basic" data-attribute="section-title">
                ${konfortifyCardBasic}
            </section>`,
          image: konfortifyCardBasicImg,
        },
        {
          id: sectionType.sectionKonfortifyBanner,
          title: 'Konfortify bannner',
          tplType: TplType.bannerMedia,
          type: sectionType.sectionKonfortifyBanner,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionKonfortifyBanner}-konfortify" data-type="${sectionType.sectionKonfortifyBanner}" data-title="Konfortify bannner" data-attribute="section-title">
                ${konfortifyBanner}
            </section>`,
          image: konfortifyBannerImg,
        },
        {
          id: sectionType.sectionKonfortifyReviewGrid,
          title: 'Konfortify review grid',
          tplType: TplType.reviewGrid,
          type: sectionType.sectionKonfortifyReviewGrid,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionKonfortifyReviewGrid}-konfortify" data-type="${sectionType.sectionKonfortifyReviewGrid}" data-title="Konfortify review grid" data-attribute="section-title">
                ${konfortifyReviewGrid}
            </section>`,
          image: konfortifyReviewGridImg,
        },
        {
          id: sectionType.sectionFurnitureshopBanner,
          title: 'Furnitureshop banner',
          tplType: TplType.bannerMedia,
          type: sectionType.sectionFurnitureshopBanner,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionFurnitureshopBanner}-furnitureshop" data-type="${sectionType.sectionFurnitureshopBanner}" data-title="Furnitureshop banner" data-attribute="section-title">
                ${furnitureshopBanner}
            </section>`,
          image: furnitureshopBannerImg,
        },
        {
          id: sectionType.sectionFurnitureshopCarousel,
          title: 'Furnitureshop carousel',
          tplType: TplType.textCarousel,
          type: sectionType.sectionFurnitureshopCarousel,
          html: `<section data-enable-anchor='false' data-section='${sectionType.sectionFurnitureshopCarousel}-furnitureshop' data-type='${sectionType.sectionFurnitureshopCarousel}' data-title='Furnitureshop carousel' data-attribute='section-title'>
                ${furnitureshopCarousel}
            </section>`,
          image: furnitureshopCarouselImg,
        },
        {
          id: sectionType.sectionFurnitureshopCardStep,
          title: 'Furnitureshop card step',
          tplType: TplType.CardStepInstructions,
          type: sectionType.sectionFurnitureshopCardStep,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionFurnitureshopCardStep}-furnitureshop" data-type="${sectionType.sectionFurnitureshopCardStep}" data-title="Furnitureshop card step" data-attribute="section-title">
                ${furnitureshopCardStep}
            </section>`,
          image: furnitureCardStepImg,
        },
        {
          id: sectionType.sectionFurnitureshopGridSlider,
          title: 'Furnitureshop grid slider',
          tplType: TplType.cardCarousel,
          type: sectionType.sectionFurnitureshopGridSlider,
          html: `<section data-enable-anchor='false' data-section='${sectionType.sectionFurnitureshopGridSlider}-furnitureshop' data-type='${sectionType.sectionFurnitureshopGridSlider}' data-title='Furnitureshop grid slider' data-attribute='section-title'>
                ${furnitureshopGridSlider}
            </section>`,
          image: furnitureGridSliderImg,
        },
        {
          id: sectionType.sectionFurnitureshopBanner02,
          title: 'Furnitureshop banner 02',
          tplType: TplType.bannerMedia,
          type: sectionType.sectionFurnitureshopBanner02,
          html: `<section data-enable-anchor='false' data-section='${sectionType.sectionFurnitureshopBanner02}-furnitureshop' data-type='${sectionType.sectionFurnitureshopBanner02}' data-title='Furnitureshop banner 02' data-attribute='section-title'>
                ${furnitureshopBanner02}
            </section>`,
          image: furnitureBanner02Img,
        },
        {
          id: sectionType.sectionFurnitureshopReward,
          title: 'Furnitureshop reward',
          tplType: TplType.Basic,
          type: sectionType.sectionFurnitureshopReward,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionFurnitureshopReward}-furnitureshop" data-type="${sectionType.sectionFurnitureshopReward}" data-title="Furnitureshop reward" data-attribute="section-title">
                ${furnitureshopReward}
            </section>`,
          image: furnitureRewardImg,
        },
        {
          id: sectionType.sectionFurnitureshopBanner03,
          title: 'Furnitureshop banner 03',
          tplType: TplType.bannerMedia,
          type: sectionType.sectionFurnitureshopBanner03,
          html: `<section data-enable-anchor='false' data-section='${sectionType.sectionFurnitureshopBanner03}-furnitureshop' data-type='${sectionType.sectionFurnitureshopBanner03}' data-title='Furnitureshop banner 03' data-attribute='section-title'>
                ${furnitureshopBanner03}
            </section>`,
          image: furnitureBanner03Img,
        },
        {
          id: sectionType.sectionFurnitureshopGridSlider02,
          title: 'Furnitureshop grid slider 02',
          tplType: TplType.cardCarousel,
          type: sectionType.sectionFurnitureshopGridSlider02,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionFurnitureshopGridSlider02}-furnitureshop" data-type="${sectionType.sectionFurnitureshopGridSlider02}" data-title="Furnitureshop grid slider 02" data-attribute="section-title">
                ${furnitureshopGridSlider02}
            </section>`,
          image: furnitureGridSlider02Img,
        },
        {
          id: sectionType.sectionFurnitureshopSpecification,
          title: 'Furnitureshop specification',
          tplType: TplType.Basic,
          type: sectionType.sectionFurnitureshopSpecification,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionFurnitureshopSpecification}-furnitureshop" data-type="${sectionType.sectionFurnitureshopSpecification}" data-title="Furnitureshop specification" data-attribute="section-title">
                ${furnitureshopSpecification}
            </section>`,
          image: furnitureSpecificationImg,
        },
        {
          id: sectionType.sectionFurnitureshopFaq,
          title: 'Furnitureshop faq',
          tplType: TplType.FaqAccordion,
          type: sectionType.sectionFurnitureshopFaq,
          html: `<section data-enable-anchor='false' data-section='${sectionType.sectionFurnitureshopFaq}-furnitureshop-faq' data-type='${sectionType.sectionFurnitureshopFaq}' data-title='Furnitureshop faq' data-attribute='section-title'>
                ${furnitureshopFaq}
            </section>`,
          image: furnitureFaqImg,
        },
        {
          id: sectionType.sectionFeetscareListImage,
          title: 'Feetscare List Image',
          tplType: TplType.markQueue,
          type: sectionType.sectionFeetscareListImage,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionFeetscareListImage}-dwd2s" data-type="${sectionType.sectionFeetscareListImage}" data-title="Feetscare List Image" data-attribute="section-title">
                ${feetscareListImageSection}
            </section>`,
          image: feetscareListImageSectionImg,
        },
        {
          id: sectionType.sectionFeetscareListItem,
          title: 'Feetscare List Item',
          tplType: TplType.Basic,
          type: sectionType.sectionFeetscareListItem,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionFeetscareListItem}-dwd2s" data-type="${sectionType.sectionFeetscareListItem}" data-title="Feetscare List Item" data-attribute="section-title">
                ${feetscareListItemSection}
            </section>`,
          image: feetscareListItemSectionImg,
        },
        {
          id: sectionType.sectionFeetscareStat,
          title: 'Feetscare Stat',
          tplType: TplType.IconsWithText,
          type: sectionType.sectionFeetscareStat,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionFeetscareStat}-dwd2s" data-type="${sectionType.sectionFeetscareStat}" data-title="Feetscare Stat" data-attribute="section-title">
                ${feetscareStatSection}
            </section>`,
          image: feetscareStatSectionImg,
        },
        {
          id: sectionType.sectionFeetscareSatellite,
          title: 'Feetscare Satellite',
          tplType: TplType.SurroundItems,
          type: sectionType.sectionFeetscareSatellite,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionFeetscareSatellite}-dwd2s" data-type="${sectionType.sectionFeetscareSatellite}" data-title="Feetscare Satellite" data-attribute="section-title">
                ${feetscareSatelliteSection}
            </section>`,
          image: feetscareSatelliteSectionImg,
        },
        {
          id: sectionType.sectionManchestoreCompareSlider,
          title: 'Manchestore compare slider',
          type: sectionType.sectionManchestoreCompareSlider,
          tplType: TplType.CardCompareTwoImage,
          html: `<section class='ck-content' data-enable-anchor='false'
                data-section='${sectionType.sectionManchestoreCompareSlider}-manchestore-compare-slider'
                data-type='${sectionType.sectionManchestoreCompareSlider}'
                data-title='Manchestore compare slider' data-attribute='section-title'>
               ${manchestoreCompareSlider}
            </section>`,
          image: manchestoreCompareSliderImg,
        },
        {
          id: sectionType.sectionManchestoreBanner,
          title: 'Manchestore banner',
          type: sectionType.sectionManchestoreBanner,
          tplType: TplType.bannerMedia,
          html: `<section class='ck-content' data-enable-anchor='false'
                data-section='${sectionType.sectionManchestoreBanner}-manchestore-banner'
                data-type='${sectionType.sectionManchestoreBanner}'
                data-title='Manchestore banner' data-attribute='section-title'>
               ${manchestoreBanner}
            </section>`,
          image: manchestoreBannerImg,
        },
        {
          id: sectionType.sectionSofyreTabsReview,
          title: 'Sofyre Tabs Review Section',
          type: sectionType.sectionSofyreTabsReview,
          tplType: TplType.Tabs,
          html: `<section data-section="${sectionType.sectionSofyreTabsReview}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionSofyreTabsReview}" data-title="Sofyre Tabs Review Section" data-attribute="section-title">
                  ${sofyreTabsReviewSection}
                </section>`,
          image: sofyreTabsReviewSectionImg,
        },
        {
          id: sectionType.sectionSofyreTimeline,
          title: 'Sofyre timeline',
          type: sectionType.sectionSofyreTimeline,
          tplType: TplType.CardTimeline,
          html: `<section class='ck-content' data-enable-anchor='false'
                data-section='${sectionType.sectionSofyreTimeline}-sofyre-timeline'
                data-type='${sectionType.sectionSofyreTimeline}'
                data-title='Sofyre timeline' data-attribute='section-title'>
               ${sofyreTimeline}
            </section>`,
          image: sofyreTimelineImg,
        },
        {
          id: sectionType.sectionSofyreIngredients,
          title: 'Sofyre ingredients',
          type: sectionType.sectionSofyreIngredients,
          tplType: TplType.ProductGrid,
          html: `<section class='ck-content' data-enable-anchor='false'
                data-section='${sectionType.sectionSofyreIngredients}-sofyre-ingredients'
                data-type='${sectionType.sectionSofyreIngredients}'
                data-title='Sofyre ingredients' data-attribute='section-title'>
               ${sofyreIngredients}
            </section>`,
          image: sofyreIngredientsImg,
        },
        {
          id: sectionType.sectionSofyreUserManual,
          title: 'Sofyre User Manual',
          type: sectionType.sectionSofyreUserManual,
          tplType: TplType.ProductGrid,
          html: `<section class='ck-content' data-enable-anchor='false'
                data-section='${sectionType.sectionSofyreUserManual}-sofyre-user-manual'
                data-type='${sectionType.sectionSofyreUserManual}'
                data-title='Sofyre User Manual' data-attribute='section-title'>
               ${sofyreUserManual}
            </section>`,
          image: sofyreUserManualImg,
        },
        {
          id: sectionType.sectionSofyreComparison,
          title: 'Sofyre Comparison Section',
          type: sectionType.sectionSofyreComparison,
          tplType: TplType.Basic,
          html: `<section data-section="${sectionType.sectionSofyreComparison}-dwd2s" data-enable-anchor="false" data-type="${sectionType.sectionSofyreComparison}" data-title="Sofyre Comparison Section" data-attribute="section-title">
                  ${sofyreComparisonSection}
                </section>`,
          image: sofyreComparisonSectionImg,
        },
        {
          id: sectionType.sectionEskiinPolicy,
          title: 'Eskiin Policy',
          type: sectionType.sectionEskiinPolicy,
          tplType: TplType.orderInfo,
          html: `<section class="ck-content" data-section="${sectionType.sectionEskiinPolicy}-es7pl1"
                data-type="${sectionType.sectionEskiinPolicy}" data-title="Eskiin Policy">
               ${eskiinPolicySection}
            </section>`,
          image: thumbnailEskiinPolicyImg,
        },
        {
          id: sectionType.sectionEskiinHurrybox,
          title: 'Eskiin hurrybox',
          tplType: TplType.FreeLayoutHurryBox,
          type: sectionType.sectionEskiinHurrybox,
          html: `<section data-enable-anchor="false" data-section="${sectionType.sectionEskiinHurrybox}-es7hb1" data-type="${sectionType.sectionEskiinHurrybox}" data-title="Eskiin hurrybox" data-attribute="section-title">
              ${eskiinHurryboxSection}
          </section>`,
          image: thumbnailEskiinImg,
        },
      ],
    };
  },
  methods: {
    wrapHtmlSection({ type, temp, title }) {
      return `
        <section data-enable-anchor="false" data-section="${type}-jhd0dv" data-type="${type}" data-title="${title}" data-attribute="section-title">
          ${temp}
        </section>
      `;
    },
  },
};
